import filterOptions2024B from './filterOptions2024B';

export type ResearchFormFilterCategoriesTitles =
  | `${ResearchFormFilterCategories}`
  | 'destinations';
enum ResearchFormFilters {
  filterOptions = 'filterOptions',
  filterOptions2020 = 'filterOptions2020',
  filterOptions2021 = 'filterOptions2021',
  filterOptions2022A = 'filterOptions2022A',
  filterOptions2022B = 'filterOptions2022B',
  filterOptions2023 = 'filterOptions2023',
  filterOptions2023B = 'filterOptions2023B',
  filterOptions2024B = 'filterOptions2024B'
}
export type FilterOption = {
  question: string;
  id: number;
  icon: string;
  answers?: {
    value: number | string;
    label: string;
  }[];
};
export type FilterOptions = {
  [key in ResearchFormFilterCategories]: FilterOption[];
};
export type IFiltersState = {
  [key in ResearchFormFilters]: FilterOptions;
};
const defaultStructureFilter: FilterOptions = {
  demographics: [],
  behaviours: [],
  factors: [],
  plannings: [],
  catalysts: [],
  barriers: [],
  enablers: []
};
export default function (): IFiltersState {
  return {
    filterOptions: {
      ...defaultStructureFilter,
      demographics: [
        {
          question: 'Gender',

          id: 2,
          icon: 'las la-clone',
          answers: [
            {
              value: '1',
              label: 'Male'
            },
            {
              value: '2',
              label: 'Female'
            }
          ]
        },
        {
          question: 'Age',

          id: 3,
          icon: 'las la-birthday-cake',
          answers: [
            {
              value: '1',
              label: '18-24 years old'
            },
            {
              value: '2',
              label: '25-34 years old'
            },
            {
              value: '3',
              label: '35-44 years old'
            },
            {
              value: '4',
              label: '45-54 years old'
            },
            {
              value: '5',
              label: '55-64 years old'
            },
            {
              value: '6',
              label: '65-74 years old'
            },
            {
              value: '7',
              label: '75+ years old'
            }
          ]
        },
        {
          question: 'Household Type',

          id: 5,
          icon: 'las la-ring',
          answers: [
            {
              value: '1',
              label: 'Single without children living at home'
            },
            {
              value: '2',
              label: 'Single with children living at home'
            },
            {
              value: '3',
              label: 'Cohabitor without children living at home'
            },
            {
              value: '4',
              label: 'Cohabitor with children living at home'
            }
          ]
        },
        {
          question: 'Household Income',

          id: 6,
          icon: 'las la-wallet',
          answers: [
            {
              value: '1',
              label: 'Below 40K EUR'
            },
            {
              value: '2',
              label: '40K - 60K EUR'
            },
            {
              value: '3',
              label: '60K - 100K EUR'
            },
            {
              value: '4',
              label: '100K EUR or more'
            }
          ]
        },
        {
          question: 'Education',

          id: 7,
          icon: 'las la-graduation-cap',
          answers: [
            {
              value: '1',
              label: 'Primary school'
            },
            {
              value: '2',
              label: 'Vocational education'
            },
            {
              value: '3',
              label: 'High school - or similar'
            },
            {
              value: '4',
              label: 'Short higher education (below 3 years)'
            },
            {
              value: '5',
              label: 'Medium higher education (3-4 year)'
            },
            {
              value: '6',
              label: 'Long higher education (5 years+)'
            }
          ]
        }
      ],
      behaviours: [
        {
          question: 'Type of Travels',

          id: 4021,
          icon: 'luggage',
          answers: [
            {
              value: '11',
              label: 'Charter/package trips with all inclusive'
            },
            {
              value: '12',
              label: 'Charter/package trips without all inclusive'
            },
            {
              value: '13',
              label: 'Camping'
            },
            {
              value: '14',
              label: 'Hotel/resort'
            },
            {
              value: '15',
              label: 'Vacation home'
            },
            {
              value: '16',
              label: 'Private rental (e.g. Airbnb)'
            },
            {
              value: '17',
              label: 'Hostel'
            },
            {
              value: '18',
              label: 'Cruise'
            },
            {
              value: '19',
              label:
                'Roadtrip (where driving around and visiting places is the central part of the trip)'
            },
            {
              value: '20',
              label:
                'Drive yourself (where you drive to one or more destinations in Europe)'
            },
            {
              value: '21',
              label: 'Skiing'
            },
            {
              value: '22',
              label: 'Round trip'
            },
            {
              value: '23',
              label: 'Group travel (min. 8 pax)'
            },
            {
              value: '24',
              label: 'Other'
            }
          ]
        },
        {
          question: 'Inspiration',

          id: 16,
          icon: 'search',
          answers: [
            {
              value: '11',
              label: 'Friends/acquaintances'
            },
            {
              value: '12',
              label: 'Facebook'
            },
            {
              value: '13',
              label: 'Instagram'
            },
            {
              value: '14',
              label: 'Snapchat'
            },
            {
              value: '15',
              label: 'Twitter'
            },
            {
              value: '16',
              label: 'Blogs'
            },
            {
              value: '17',
              label: 'Online reviews'
            },
            {
              value: '18',
              label: 'Print media '
            },
            {
              value: '19',
              label: 'Print brochures '
            },
            {
              value: '20',
              label: 'Online brochures'
            },
            {
              value: '21',
              label: 'TV (flow-TV or on-demand)'
            },
            {
              value: '22',
              label: 'None of the above'
            }
          ]
        },
        {
          question: 'Booking type',

          id: 4020,
          icon: 'store',
          answers: [
            {
              value: '1',
              label: 'Book package trip (flight+accommodation) online'
            },
            {
              value: '2',
              label:
                'Book package trip (flight+accommodation) at travel agencies via personal contact (tlf/store) '
            },
            {
              value: '3',
              label:
                'Book seperate flight and hotel online via different booking portals/travel agencies'
            },
            {
              value: '4',
              label:
                "Book accommodation directly via the accommodation's website "
            },
            {
              value: '5',
              label:
                'Book transport directly at the airfare/car rental/bus company/cruise website'
            },
            {
              value: '6',
              label:
                'Use price comparison site (e.g. Momondo, Trivago, Skyscanner)'
            }
          ]
        },
        {
          question: 'Hotel rating (stars)',

          id: 18,
          icon: 'grade',
          answers: [
            {
              value: '1',
              label: '1'
            },
            {
              value: '2',
              label: '2'
            },
            {
              value: '3',
              label: '3'
            },
            {
              value: '4',
              label: '4'
            },
            {
              value: '5',
              label: '5'
            }
          ]
        },
        {
          question: 'Luxury',

          id: 19,
          icon: 'paid',
          answers: [
            {
              value: '1',
              label: 'Flown first class'
            },
            {
              value: '2',
              label: 'Flown business class'
            },
            {
              value: '3',
              label: 'Booked a suite on a 5-star hotel'
            },
            {
              value: '4',
              label: 'Payed for a service-upgrade on a 5-star hotel'
            },
            {
              value: '5',
              label: 'None of the above'
            }
          ]
        }
      ],
      factors: [
        {
          question: 'Price level in the country (affordability)',
          id: 127,
          icon: 'las la-hand-holding-usd',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Environmental concerns and sustainability',
          id: 128,
          icon: 'las la-leaf',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Safety standards/low crime levels',
          id: 129,
          icon: 'las la-shield-alt',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Cleanliness',
          id: 131,
          icon: 'las la-broom',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Opportunities for going to theme parks',
          id: 143,
          icon: 'las la-laugh-beam',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Going to the beach',
          id: 137,
          icon: 'las la-umbrella-beach',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Shopping',
          id: 132,
          icon: 'las la-shopping-bag',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Being active (Sport, adventure)',
          id: 148,
          icon: 'las la-shopping-bag',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Wellness/Spa',
          id: 139,
          icon: 'las la-spa',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Nature/outdoor experiences',
          id: 133,
          icon: 'las la-mountain',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Cultural experiences (museums, concerts, theaters)',
          id: 167,
          icon: 'las la-theater-masks',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Historical experiences',
          id: 135,
          icon: 'las la-landmark',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Guided/Arranged tours/experiences',
          id: 149,
          icon: 'las la-running',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Big city experiences',
          id: 150,
          icon: 'las la-city',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Exciting food experience opportunities',
          id: 140,
          icon: 'las la-utensils',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Fine dining',
          id: 141,
          icon: 'las la-concierge-bell',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question:
            'Gaining a new skill/developing skill, e.g. language, cooking or similar',
          id: 138,
          icon: 'las la-sign-language',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Child friendliness',
          id: 130,
          icon: 'las la-baby-carriage',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'That the destination has few tourists',
          id: 142,
          icon: 'las la-user-alt-slash',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Living new experiences',
          id: 151,
          icon: 'las la-fire-alt',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Meeting new people',
          id: 152,
          icon: 'las la-user-friends',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Interacting with locals',
          id: 153,
          icon: 'las la-language',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Easy access to health and medical facilities',
          id: 154,
          icon: 'las la-ambulance',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Accessibility for less mobile',
          id: 155,
          icon: 'las la-wheelchair',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'LGBTQ+-friendly',
          id: 156,
          icon: 'las la-mercury',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Minimizing my carbon footprint',
          id: 157,
          icon: 'las la-smog',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'All inclusive accommodation options',
          id: 158,
          icon: 'las la-wallet',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Direct flight',
          id: 159,
          icon: 'las la-plane',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Flights from my local airport',
          id: 160,
          icon: 'las la-plane-departure',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Being able to drive to the destination',
          id: 161,
          icon: 'las la-truck-pickup',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Health and hygiene standards',
          id: 162,
          icon: 'las la-notes-medical',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Pet friendly',
          id: 163,
          icon: 'las la-dog',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Nightlife',
          id: 164,
          icon: 'las la-glass-cheers',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Photography',
          id: 165,
          icon: 'las la-camera',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question:
            'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
          id: 166,
          icon: 'las la-money-bill',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        }
      ],
      plannings: [
        {
          question: 'Spendings (12 months)',

          id: 8,
          icon: 'las la-wallet',
          answers: [
            {
              value: '1',
              label: 'Below 650 EUR'
            },
            {
              value: '2',
              label: '650-1.500 EUR'
            },
            {
              value: '3',
              label: '1.500-2.000 EUR'
            },
            {
              value: '4',
              label: '2.000-2.500 EUR'
            },
            {
              value: '5',
              label: '2.500-3.000 EUR'
            },
            {
              value: '6',
              label: '3.000-4.000 EUR'
            },
            {
              value: '7',
              label: '4.000-4.500 EUR'
            },
            {
              value: '8',
              label: '4.500-5.000 EUR'
            },
            {
              value: '9',
              label: '5.000-6.000 EUR'
            },
            {
              value: '10',
              label: '6.000-6.500 EUR'
            },
            {
              value: '11',
              label: '6.500 EUR or more'
            }
          ]
        },
        {
          question: 'Budget',

          id: 9,
          icon: 'legend_toggle',
          answers: [
            {
              value: '1',
              label: 'Budget this year is smaller than the previous year'
            },
            {
              value: '2',
              label: 'The same'
            },
            {
              value: '3',
              label: 'Budget this year is bigger than the previous year'
            }
          ]
        },
        {
          question: 'Short travels (this year)',

          id: 10,
          icon: 'event',
          answers: [
            {
              value: '1',
              label: 'None'
            },
            {
              value: '2',
              label: '1'
            },
            {
              value: '3',
              label: '2'
            },
            {
              value: '4',
              label: '3'
            },
            {
              value: '5',
              label: '4'
            },
            {
              value: '6',
              label: '5'
            },
            {
              value: '7',
              label: '6 or more'
            }
          ]
        },
        {
          question: 'Long travels (this year)',

          id: 11,
          icon: 'event_note',
          answers: [
            {
              value: '1',
              label: 'None'
            },
            {
              value: '2',
              label: '1'
            },
            {
              value: '3',
              label: '2'
            },
            {
              value: '4',
              label: '3'
            },
            {
              value: '5',
              label: '4'
            },
            {
              value: '6',
              label: '5'
            },
            {
              value: '7',
              label: '6 or more'
            }
          ]
        },
        {
          question: 'Short travels (next year)',

          id: 12,
          icon: 'event',
          answers: [
            {
              value: '1',
              label: 'None'
            },
            {
              value: '2',
              label: '1'
            },
            {
              value: '3',
              label: '2'
            },
            {
              value: '4',
              label: '3'
            },
            {
              value: '5',
              label: '4'
            },
            {
              value: '6',
              label: '5'
            },
            {
              value: '7',
              label: '6 or more'
            }
          ]
        },
        {
          question: 'Long travels (next year)',

          id: 13,
          icon: 'event_note',
          answers: [
            {
              value: '1',
              label: 'None'
            },
            {
              value: '2',
              label: '1'
            },
            {
              value: '3',
              label: '2'
            },
            {
              value: '4',
              label: '3'
            },
            {
              value: '5',
              label: '4'
            },
            {
              value: '6',
              label: '5'
            },
            {
              value: '7',
              label: '6 or more'
            }
          ]
        }
      ],
      barriers: [
        {
          question: 'Political instability in destination',
          id: 1617,
          icon: 'las la-city'
        },
        {
          question: 'Political instability in my country',
          id: 1618,
          icon: 'las la-landmark'
        },
        {
          question: 'Threat of terrorist attack',
          id: 1619,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Global health concerns (covid, monkey pox)',
          id: 1620,
          icon: 'las la-heart'
        },
        {
          question: 'International conflicts',
          id: 1621,
          icon: 'las la-exclamation-triangle'
        },
        {
          question: 'Inconvenience in airports (delays/cancellations)',
          id: 1622,
          icon: 'las la-plane-arrival'
        },
        {
          question: 'Increase of cost of holidays',
          id: 1623,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Cost of living increase affecting disposable income',
          id: 1624,
          icon: 'las la-money-bill'
        },
        {
          question: 'Natural disasters or extreme weather at the destination',
          id: 1625,
          icon: 'las la-snowflake'
        }
      ]
    },
    filterOptions2020: {
      ...defaultStructureFilter,
      demographics: [
        {
          question: 'Gender',

          id: 2,
          icon: 'las la-clone',
          answers: [
            {
              value: '1',
              label: 'Male'
            },
            {
              value: '2',
              label: 'Female'
            }
          ]
        },
        {
          question: 'Age',

          id: 3,
          icon: 'las la-birthday-cake',
          answers: [
            {
              value: '1',
              label: '18-24 years old'
            },
            {
              value: '2',
              label: '25-34 years old'
            },
            {
              value: '3',
              label: '35-44 years old'
            },
            {
              value: '4',
              label: '45-54 years old'
            },
            {
              value: '5',
              label: '55-64 years old'
            },
            {
              value: '6',
              label: '65-74 years old'
            },
            {
              value: '7',
              label: '75+ years old'
            }
          ]
        },
        {
          question: 'Household Type',

          id: 1005,
          icon: 'las la-ring',
          answers: [
            {
              value: '1',
              label: 'Family only w. children of age 0-7'
            },
            {
              value: '2',
              label: 'Family only w. children of age 8-17'
            },
            {
              value: '3',
              label: 'Family w. children of age 0-7 and 8-17'
            },
            {
              value: '4',
              label: 'Single only w. children of age 0-7'
            },
            {
              value: '5',
              label: 'Single only w. children of age 8-17'
            },
            {
              value: '6',
              label: 'Single w. children of age 0-7 and 8-17'
            },
            {
              value: '7',
              label: 'Single without children'
            },
            {
              value: '8',
              label: 'Couple without children'
            },
            {
              value: '9',
              label: 'Other type'
            }
          ]
        },
        {
          question: 'Household Income',

          id: 6,
          icon: 'las la-wallet',
          answers: [
            {
              value: '1',
              label: 'Below 20K EUR'
            },
            {
              value: '2',
              label: '20K - 40K EUR'
            },
            {
              value: '3',
              label: '40K - 65K EUR'
            },
            {
              value: '4',
              label: '65K - 95K EUR'
            },
            {
              value: '5',
              label: '95K - 150K EUR'
            },
            {
              value: '6',
              label: '150K EUR or more'
            }
          ]
        },
        {
          question: 'Education',

          id: 7,
          icon: 'las la-graduation-cap',
          answers: [
            {
              value: '1',
              label: 'School'
            },
            {
              value: '2',
              label: 'Vocational education'
            },
            {
              value: '3',
              label: 'Bachelors degree or similar'
            },
            {
              value: '4',
              label: 'Master degree or similar or above'
            }
          ]
        }
      ],
      behaviours: [
        {
          question: 'Preferred holiday type',

          id: 4022,
          icon: 'near_me',
          answers: [
            { value: 1, label: 'Sun and beach holiday' },
            { value: 2, label: 'Skiing holiday' },
            {
              value: 3,
              label:
                'Cultural holiday (where historical and cultural experiences are the main purpose)'
            },
            { value: 4, label: 'Cruise' },
            {
              value: 5,
              label:
                'Round trip (multiple locations/destinations in one holiday)'
            },
            { value: 6, label: 'Group holiday (min. 8 pax)' },
            { value: 7, label: 'Big city holiday' },
            { value: 8, label: 'Religious holiday' },
            {
              value: 9,
              label:
                'Special occations travel, eg. Stag or hen trip, anniversary or birthday celebration'
            },
            {
              value: 10,
              label: 'Active holiday (hiking, sport, surfing, climbing ect.)'
            },
            { value: 11, label: 'Volunteering as part of the holiday' },
            {
              value: 12,
              label: 'Doing my hobby (golf, birdwatching, hunting, diving)'
            },
            { value: 13, label: 'Wedding or honeymoon' },
            {
              value: 14,
              label: 'Visiting/experiencing festivals, events, sports events'
            },
            { value: 15, label: 'Visiting friends and family' },
            {
              value: 16,
              label: 'Getting culinary experiences (food, wine, whiskey, beer)'
            },
            {
              value: 17,
              label: 'Relaxing (unwind, getting into a lower gear)'
            },
            {
              value: 18,
              label:
                'Doing something good for myself (wellness, retreat, yoga, spa)'
            },
            { value: 19, label: 'Meeting new people' }
          ]
        },
        {
          question: 'Preferred type of accommodation',

          id: 4021,
          icon: 'luggage',
          answers: [
            {
              value: 1,
              label: 'Camping (caravan, autocamper, mobile home, tent)'
            },
            { value: 2, label: 'Glamping (luxury camping)' },
            {
              value: 3,
              label: 'Holiday home (not your own privately owned home)'
            },
            {
              value: 4,
              label: 'Private rental (e.g. Airbnb, Homeaway, house swap)'
            },
            { value: 5, label: 'My own private home at the destination' },
            { value: 6, label: 'Bed and Breakfast' },
            { value: 7, label: 'Budget hotel/hostel' },
            { value: 8, label: 'Farmhouse' },
            { value: 9, label: 'Traditional/historic property' },
            { value: 10, label: 'Independent 3-4* hotel' },
            { value: 11, label: 'Boutique hotel' },
            { value: 12, label: 'City hotel' },
            { value: 13, label: 'Globally recognised hotel brand' },
            { value: 14, label: 'Resort' },
            { value: 15, label: 'Luxury hotel (5+*)' },
            { value: 16, label: 'Spahotel' },
            {
              value: 17,
              label: 'Contemporary style accommodation/design hotel'
            },
            { value: 18, label: 'Staying with friends or family' }
          ]
        },
        {
          question: 'Inspiration',

          id: 16,
          icon: 'search',
          answers: [
            { value: 1, label: 'Friends/acquaintances' },
            { value: 2, label: 'Facebook' },
            { value: 3, label: 'Instagram' },
            { value: 4, label: 'Snapchat' },
            { value: 5, label: 'Twitter' },
            { value: 6, label: 'Blogs' },
            { value: 7, label: 'Podcasts' },
            { value: 8, label: 'TikTok' },
            { value: 9, label: 'Youtube' },
            { value: 10, label: 'Online reviews' },
            { value: 11, label: 'Print media' },
            { value: 12, label: 'Online media' },
            { value: 13, label: 'Print brochures' },
            { value: 14, label: 'Online brochures' },
            { value: 15, label: 'Influencers and celebrities' },
            { value: 16, label: 'Cinema/movies' },
            { value: 17, label: 'TV advertising' },
            { value: 18, label: 'Travel TV programmes' },
            { value: 19, label: 'Radio' },
            { value: 20, label: 'Search engines (Google, Bing..)' },
            { value: 21, label: 'Travel agency recommendation' },
            { value: 22, label: 'Travel company websites' }
          ]
        },
        {
          question: 'Booking type',

          id: 4020,
          icon: 'store',
          answers: [
            {
              value: 1,
              label:
                'Book package trip (flight+accommodation) online at travel agency website'
            },
            {
              value: 2,
              label:
                'Book package trip (flight+accommodation) with a travel agent in person or via phone/email'
            },
            {
              value: 3,
              label:
                'Book seperate flight and hotel online via different booking portals/travel agencies'
            },
            {
              value: 4,
              label:
                'Book package (flight and accommodation) direct with tour operator'
            },
            {
              value: 5,
              label:
                "Book accommodation directly via the accommodation's website"
            },
            {
              value: 6,
              label:
                'Book transportation directly via the airline/car rental/rail/coach/cruise website'
            },
            {
              value: 7,
              label:
                'Use price comparison site (e.g. Momondo, Trivago, Skyscanner)'
            }
          ]
        },
        {
          question: 'Luxury',

          id: 19,
          icon: 'paid',
          answers: [
            { value: 1, label: 'Flown first class/business class' },
            { value: 2, label: 'Flown premium economy' },
            { value: 3, label: 'Stayed at a suite/villa' },
            { value: 4, label: 'Paid extra for butler/maid/chef' }
          ]
        }
      ],
      factors: [
        {
          question: 'Price level in the country (affordability)',
          id: 127,
          icon: 'las la-hand-holding-usd',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Environmental concerns and sustainability',
          id: 128,
          icon: 'las la-leaf',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Safety standards/low crime levels',
          id: 129,
          icon: 'las la-shield-alt',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Cleanliness',
          id: 131,
          icon: 'las la-broom',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Opportunities for going to theme parks',
          id: 143,
          icon: 'las la-laugh-beam',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Going to the beach',
          id: 137,
          icon: 'las la-umbrella-beach',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Shopping',
          id: 132,
          icon: 'las la-shopping-bag',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Being active (Sport, adventure)',
          id: 148,
          icon: 'las la-shopping-bag',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Wellness/Spa',
          id: 139,
          icon: 'las la-spa',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Nature/outdoor experiences',
          id: 133,
          icon: 'las la-mountain',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Cultural experiences (museums, concerts, theaters)',
          id: 167,
          icon: 'las la-theater-masks',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Historical experiences',
          id: 135,
          icon: 'las la-landmark',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Guided/Arranged tours/experiences',
          id: 149,
          icon: 'las la-running',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Big city experiences',
          id: 150,
          icon: 'las la-city',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Exciting food experience opportunities',
          id: 140,
          icon: 'las la-utensils',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Fine dining',
          id: 141,
          icon: 'las la-concierge-bell',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question:
            'Gaining a new skill/developing skill, e.g. language, cooking or similar',
          id: 138,
          icon: 'las la-sign-language',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Child friendliness',
          id: 130,
          icon: 'las la-baby-carriage',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'That the destination has few tourists',
          id: 142,
          icon: 'las la-user-alt-slash',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Living new experiences',
          id: 151,
          icon: 'las la-fire-alt',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Meeting new people',
          id: 152,
          icon: 'las la-user-friends',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Interacting with locals',
          id: 153,
          icon: 'las la-language',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Easy access to health and medical facilities',
          id: 154,
          icon: 'las la-ambulance',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Accessibility for less mobile',
          id: 155,
          icon: 'las la-wheelchair',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'LGBTQ+-friendly',
          id: 156,
          icon: 'las la-mercury',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Minimizing my carbon footprint',
          id: 157,
          icon: 'las la-smog',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'All inclusive accommodation options',
          id: 158,
          icon: 'las la-wallet',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Direct flight',
          id: 159,
          icon: 'las la-plane',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Flights from my local airport',
          id: 160,
          icon: 'las la-plane-departure',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Being able to drive to the destination',
          id: 161,
          icon: 'las la-truck-pickup',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Health and hygiene standards',
          id: 162,
          icon: 'las la-notes-medical',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Pet friendly',
          id: 163,
          icon: 'las la-dog',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Nightlife',
          id: 164,
          icon: 'las la-glass-cheers',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question: 'Photography',
          id: 165,
          icon: 'las la-camera',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        },
        {
          question:
            'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
          id: 166,
          icon: 'las la-money-bill',
          answers: [
            {
              value: '1',
              label: 'Very little importance'
            },
            {
              value: '2',
              label: 'Little importance'
            },
            {
              value: '3',
              label: 'Some importance'
            },
            {
              value: '4',
              label: 'Great importance'
            },
            {
              value: '5',
              label: 'Extreme importance'
            }
          ]
        }
      ],
      plannings: [
        {
          question: 'Spendings (12 months)',

          id: 8,
          icon: 'las la-wallet',
          answers: [
            {
              value: '1',
              label: 'Below 1.000 EUR'
            },
            {
              value: '2',
              label: '1.000-3.000 EUR'
            },
            {
              value: '3',
              label: '3.000-5.000 EUR'
            },
            {
              value: '4',
              label: '5.000-10.000 EUR'
            },
            {
              value: '5',
              label: '10.000-20.000 EUR'
            },
            {
              value: '6',
              label: '20.000-30.000 EUR'
            },
            {
              value: '7',
              label: '30.000-40.000 EUR'
            },
            {
              value: '8',
              label: '40.000-50.000 EUR'
            },
            {
              value: '9',
              label: '50.000 EUR or more'
            }
          ]
        },
        {
          question: 'Budget',

          id: 9,
          icon: 'legend_toggle',
          answers: [
            {
              value: '1',
              label: 'Budget this year is smaller than the previous year'
            },
            {
              value: '2',
              label: 'Budget is the same'
            },
            {
              value: '3',
              label: 'Budget this year is bigger than the previous year'
            }
          ]
        },
        {
          question: 'Short holidays (up to 4 days)',

          id: 1274,
          icon: 'event',
          answers: [
            { value: 1, label: 'January' },
            { value: 2, label: 'February' },
            { value: 3, label: 'March' },
            { value: 4, label: 'April' },
            { value: 5, label: 'May' },
            { value: 6, label: 'June' },
            { value: 7, label: 'July' },
            { value: 8, label: 'August' },
            { value: 9, label: 'September' },
            { value: 10, label: 'October' },
            { value: 11, label: 'November' },
            { value: 12, label: 'December' }
          ]
        },
        {
          question: 'Long holidays (5 days or more)',

          id: 1255,
          icon: 'event_note',
          answers: [
            { value: 1, label: 'January' },
            { value: 2, label: 'February' },
            { value: 3, label: 'March' },
            { value: 4, label: 'April' },
            { value: 5, label: 'May' },
            { value: 6, label: 'June' },
            { value: 7, label: 'July' },
            { value: 8, label: 'August' },
            { value: 9, label: 'September' },
            { value: 10, label: 'October' },
            { value: 11, label: 'November' },
            { value: 12, label: 'December' }
          ]
        },
        {
          question: 'Short international holidays (up to 4 days)',

          id: 1254,
          icon: 'event',
          answers: [
            { value: 1, label: 'January' },
            { value: 2, label: 'February' },
            { value: 3, label: 'March' },
            { value: 4, label: 'April' },
            { value: 5, label: 'May' },
            { value: 6, label: 'June' },
            { value: 7, label: 'July' },
            { value: 8, label: 'August' },
            { value: 9, label: 'September' },
            { value: 10, label: 'October' },
            { value: 11, label: 'November' },
            { value: 12, label: 'December' }
          ]
        },
        {
          question: 'Long international holidays (5 days or more)',

          id: 1265,
          icon: 'event_note',
          answers: [
            { value: 1, label: 'January' },
            { value: 2, label: 'February' },
            { value: 3, label: 'March' },
            { value: 4, label: 'April' },
            { value: 5, label: 'May' },
            { value: 6, label: 'June' },
            { value: 7, label: 'July' },
            { value: 8, label: 'August' },
            { value: 9, label: 'September' },
            { value: 10, label: 'October' },
            { value: 11, label: 'November' },
            { value: 12, label: 'December' }
          ]
        }
      ],
      barriers: [
        {
          question: 'Political instability in destination',
          id: 1617,
          icon: 'las la-city'
        },
        {
          question: 'Political instability in my country',
          id: 1618,
          icon: 'las la-landmark'
        },
        {
          question: 'Threat of terrorist attack',
          id: 1619,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Global health concerns (covid, monkey pox)',
          id: 1620,
          icon: 'las la-heart'
        },
        {
          question: 'International conflicts',
          id: 1621,
          icon: 'las la-exclamation-triangle'
        },
        {
          question: 'Inconvenience in airports (delays/cancellations)',
          id: 1622,
          icon: 'las la-plane-arrival'
        },
        {
          question: 'Increase of cost of holidays',
          id: 1623,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Cost of living increase affecting disposable income',
          id: 1624,
          icon: 'las la-money-bill'
        },
        {
          question: 'Natural disasters or extreme weather at the destination',
          id: 1625,
          icon: 'las la-snowflake'
        }
      ]
    },
    filterOptions2021: {
      ...defaultStructureFilter,
      demographics: [
        {
          question: 'Gender',
          id: 2,
          icon: 'las la-clone',
          answers: [
            {
              value: 1,
              label: 'Male'
            },
            {
              value: 2,
              label: 'Female'
            },
            {
              value: 3,
              label: 'Other'
            }
          ]
        },
        {
          question: 'Age',
          id: 3,
          icon: 'las la-birthday-cake',
          answers: [
            {
              value: '1',
              label: '18-24 years'
            },
            {
              value: '2',
              label: '25-34 years'
            },
            {
              value: '3',
              label: '35-44 years'
            },
            {
              value: '4',
              label: '45-54 years'
            },
            {
              value: '5',
              label: '55-64 years'
            },
            {
              value: '6',
              label: '65-74 years'
            },
            {
              value: '7',
              label: '75+ years'
            }
          ]
        },
        {
          question: 'Civil Status',
          id: 5,
          icon: 'las la-ring',
          answers: [
            {
              value: 1,
              label: 'Single'
            },
            {
              value: 2,
              label: 'In a relationship'
            },
            {
              value: 3,
              label: 'Co-habiting/Married'
            }
          ]
        },
        // {
        //   question: 'Age of children/shared children',
        //   id: 1006,
        //   icon: 'las la-child',
        //   answers: [
        //     {
        //       value: 1,
        //       label: 'Do not have children/Do not have children living at home'
        //     },
        //     {
        //       value: 2,
        //       label: '0-1 year'
        //     },
        //     {
        //       value: 3,
        //       label: '2 years'
        //     },
        //     {
        //       value: 4,
        //       label: '3 years'
        //     },
        //     {
        //       value: 5,
        //       label: '4 years'
        //     },
        //     {
        //       value: 6,
        //       label: '5 years'
        //     },
        //     {
        //       value: 7,
        //       label: '6 years'
        //     },
        //     {
        //       value: 8,
        //       label: '7 years'
        //     },
        //     {
        //       value: 9,
        //       label: '8 years'
        //     },
        //     {
        //       value: 10,
        //       label: '9 years'
        //     },
        //     {
        //       value: 11,
        //       label: '10 years'
        //     },
        //     {
        //       value: 12,
        //       label: '11 years'
        //     },
        //     {
        //       value: 13,
        //       label: '12 years'
        //     },
        //     {
        //       value: 14,
        //       label: '13 years'
        //     },
        //     {
        //       value: 15,
        //       label: '14 years'
        //     },
        //     {
        //       value: 16,
        //       label: '15 years'
        //     },
        //     {
        //       value: 17,
        //       label: '16 years'
        //     },
        //     {
        //       value: 18,
        //       label: '17 years'
        //     },
        //     {
        //       value: 19,
        //       label: '18 years+'
        //     }
        //   ]
        // },
        {
          question: 'Household Income',
          id: 6,
          icon: 'las la-wallet',
          answers: [
            {
              value: 1,
              label: 'Under 18.000 EUR'
            },
            {
              value: 2,
              label: '18.000 - 35.999 EUR'
            },
            {
              value: 3,
              label: '36.000 - 58.999 EUR'
            },
            {
              value: 4,
              label: '59.000 - 85.999 EUR'
            },
            {
              value: 5,
              label: '86.000 - 129.999 EUR'
            },
            {
              value: 6,
              label: '130.000 - 176.999 EUR'
            },
            {
              value: 7,
              label: '177.000 - 224.999 EUR'
            },
            {
              value: 8,
              label: 'Over 225.000 EUR'
            },
            {
              value: 9,
              label: 'Do not know/Do not want to state'
            }
          ]
        },
        {
          question: 'Education',
          id: 7,
          icon: 'las la-graduation-cap',
          answers: [
            {
              value: 1,
              label: 'School'
            },
            {
              value: 2,
              label: 'Vocational education'
            },
            {
              value: 3,
              label: 'Bachelors degree or similar'
            },
            {
              value: 4,
              label: 'Master degree or similar or above'
            }
          ]
        }
      ],
      behaviours: [
        {
          question: 'Social And Environmental Responsibility',
          id: 1019,
          icon: 'las la-dove',
          answers: [
            {
              value: 1,
              label: 'Compensated CO2 emissions'
            },
            {
              value: 2,
              label: 'Chosen a train or bus over a plane ticket'
            },
            {
              value: 3,
              label:
                'Taken part in a rural / local community experience to share their domestic life'
            },
            {
              value: 4,
              label: 'Supported a social conservation project (activism)'
            },
            {
              value: 5,
              label:
                'Supported a environmental / biodiversity conservation project (activism)'
            },
            {
              value: 6,
              label:
                'Chosen ecofriendly accommodation in spite of costing more than a regular one'
            },
            {
              value: 7,
              label: 'None of the above'
            }
          ]
        },
        {
          question: 'Preferred holiday type',
          id: 4022,
          icon: 'near_me',
          answers: [
            {
              value: 1,
              label: 'Sun and beach holiday'
            },
            {
              value: 2,
              label: 'Skiing holiday'
            },
            {
              value: 3,
              label:
                'Cultural holiday (where historical and cultural experiences are the main purpose)'
            },
            {
              value: 4,
              label: 'Cruise holiday'
            },
            {
              value: 5,
              label:
                'Multi destination tour (multiple locations/destinations in one holiday)'
            },
            {
              value: 6,
              label: 'Group holiday (min. 8 pax)'
            },
            {
              value: 7,
              label: 'Big city holiday'
            },
            {
              value: 8,
              label: 'Religious (Pilgrimage, practice religion)'
            },
            {
              value: 9,
              label:
                'Special occation travel, eg. Stag or hen party, anniversary or birthday celebration'
            },
            {
              value: 10,
              label:
                'Other Active holiday (hiking, sport, surfing, climbing, riding ect.)'
            },
            {
              value: 11,
              label: 'Volunteering as part of the holiday'
            },
            {
              value: 12,
              label: 'Birdwatching, Safari'
            },
            {
              value: 13,
              label: 'Wedding or honeymoon'
            },
            {
              value: 14,
              label: 'Attending festivals, events, sports events'
            },
            {
              value: 15,
              label: 'Visiting friends and family'
            },
            {
              value: 16,
              label: 'Gastronomic/culinary/wine experiences'
            },
            {
              value: 17,
              label: 'Relaxing (unwind, getting into a lower gear)'
            },
            {
              value: 18,
              label:
                'Doing something good for myself (wellness, retreat, yoga, spa)'
            },
            {
              value: 22,
              label: 'Golf holiday'
            },
            {
              value: 23,
              label: 'Diving holiday'
            },
            {
              value: 24,
              label:
                'Combining business and pleasure (extending business travel)'
            }
          ]
        },
        {
          question: 'Preferred type of accommodation',
          id: 4021,
          icon: 'luggage',
          answers: [
            {
              value: 1,
              label: 'Camping (caravan, autocamper, mobile home, tent)'
            },
            {
              value: 2,
              label: 'Glamping (luxury camping)'
            },
            {
              value: 3,
              label: 'Holiday home (not my own privately owned home)'
            },
            {
              value: 4,
              label: 'Private rental (e.g. Airbnb, Homeaway, house swap)'
            },
            {
              value: 5,
              label: 'My own private home at the destination'
            },
            {
              value: 6,
              label: 'Bed and Breakfast'
            },
            {
              value: 7,
              label: 'Budget Hotel/Hostel'
            },
            {
              value: 8,
              label: 'Farmhouse'
            },
            {
              value: 9,
              label: 'Traditional/ Historic property'
            },
            {
              value: 10,
              label: '3-4* Hotel'
            },
            {
              value: 11,
              label: 'Boutique Hotel'
            },
            {
              value: 12,
              label: 'City hotel'
            },
            {
              value: 13,
              label:
                'Globally recognised hotel brand (Hilton, Marriott, Sheraton, etc.)'
            },
            {
              value: 14,
              label: 'Resort'
            },
            {
              value: 15,
              label: 'Luxury Hotel (5+*)'
            },
            {
              value: 16,
              label: 'Spa hotel'
            },
            {
              value: 17,
              label: 'Contemporary style accommodation/design hotel'
            },
            {
              value: 18,
              label: 'Staying with friends or family'
            },
            {
              value: 21,
              label: 'Boating (house boat, yacht)'
            },
            {
              value: 22,
              label: 'Luxury suite/villa'
            },
            {
              value: 23,
              label: 'Cruise'
            }
          ]
        },
        {
          question: 'Inspiration',
          id: 16,
          icon: 'search',
          answers: [
            {
              value: 2,
              label: 'Facebook'
            },
            {
              value: 3,
              label: 'Instagram'
            },
            {
              value: 4,
              label: 'Snapchat'
            },
            {
              value: 5,
              label: 'Twitter'
            },
            {
              value: 6,
              label: 'Blogs'
            },
            {
              value: 7,
              label: 'Podcasts'
            },
            {
              value: 8,
              label: 'TikTok'
            },
            {
              value: 9,
              label: 'Youtube'
            },
            {
              value: 10,
              label: 'Online reviews sites (Tripadvisor, etc.)'
            },
            {
              value: 12,
              label: 'Online media'
            },
            {
              value: 13,
              label: 'Online lifestyle and travel magazines'
            },
            {
              value: 15,
              label: 'Influencers and celebrities'
            },
            {
              value: 20,
              label: 'Search engines (Google, Bing..)'
            },
            {
              value: 21,
              label: 'Online Travel Agencies'
            },
            {
              value: 22,
              label: 'Travel company websites (airline, hotels, etc.)'
            },
            {
              value: 24,
              label: 'Twitch'
            },
            {
              value: 25,
              label: 'Wechat'
            },
            {
              value: 26,
              label: 'Oficial tourism board / office website'
            }
          ]
        },
        {
          question: 'Inspiration Offline',
          id: 1016,
          icon: 'las la-search-location',
          answers: [
            {
              value: 1,
              label: 'Family & friends'
            },
            {
              value: 11,
              label: 'Newspapers and Supplements'
            },
            {
              value: 16,
              label: 'Cinema/movies'
            },
            {
              value: 17,
              label: 'TV advertising'
            },
            {
              value: 18,
              label: 'Travel TV programmes'
            },
            {
              value: 19,
              label: 'Radio'
            },
            {
              value: 27,
              label: 'Outdoor advertising'
            },
            {
              value: 28,
              label: 'Promotional Events'
            },
            {
              value: 29,
              label: 'Travel agency recommendation / Shop windows'
            },
            {
              value: 30,
              label: 'Lifestyle and travel print magazines'
            }
          ]
        },
        {
          question: 'Booking',
          id: 4020,
          icon: 'store',
          answers: [
            {
              value: 1,
              label:
                'Book package trip (flight+accommodation) online at travel agency website'
            },
            {
              value: 2,
              label:
                'Book package trip (flight+accommodation) with a travel agent in person or via phone/email'
            },
            {
              value: 3,
              label:
                'Book seperate flight and hotel online via different booking portals/travel agencies'
            },
            {
              value: 4,
              label:
                'Book package (flight and accommodation) direct with tour operator'
            },
            {
              value: 5,
              label:
                "Book accommodation directly via the accommodation's website"
            },
            {
              value: 6,
              label:
                'Book transportation directly via the airline/car rental/rail/coach/cruise website'
            },
            {
              value: 7,
              label:
                'Use price comparison site (e.g. Momondo, Trivago, Skyscanner)'
            }
          ]
        },
        {
          question: 'Transportation',
          id: 5019,
          icon: 'las la-car',
          answers: [
            {
              value: 1,
              label: 'Own vehicle'
            },
            {
              value: 2,
              label: 'Rental Car'
            },
            {
              value: 3,
              label: 'Bus'
            },
            {
              value: 4,
              label: 'Train'
            },
            {
              value: 5,
              label: 'Flight first class/business class'
            },
            {
              value: 6,
              label: 'Flight premium economy / economy'
            },
            {
              value: 7,
              label: 'Ferry'
            },
            {
              value: 8,
              label: 'Private boats (small cruices / yatching)'
            },
            {
              value: 9,
              label: 'Cruise'
            }
          ]
        },
        {
          question: 'Apprehension level',
          id: 1021,
          icon: 'las la-asterisk',
          answers: [
            {
              value: 1,
              label: 'Yes, definitely'
            },
            {
              value: 2,
              label: 'Yes, if I myself feel that it is safe'
            },
            {
              value: 3,
              label: 'Maybe if it is a really good offer'
            },
            {
              value: 4,
              label: 'No'
            }
          ]
        },
        {
          question: 'Duty Free Frequency',
          id: 1022,
          icon: 'las la-store',
          answers: [
            {
              value: 1,
              label: 'Never'
            },
            {
              value: 2,
              label: 'Rarely'
            },
            {
              value: 3,
              label: 'Often'
            },
            {
              value: 4,
              label: 'Always'
            }
          ]
        },
        {
          question: 'Duty Free Products',
          id: 1017,
          icon: 'las la-wine-bottle',
          answers: [
            {
              value: 1,
              label: 'Beauty'
            },
            {
              value: 2,
              label: 'Wine & Spirits'
            },
            {
              value: 3,
              label: 'Tobacco'
            },
            {
              value: 4,
              label: 'Confectionery'
            },
            {
              value: 5,
              label: 'Fine Food'
            },
            {
              value: 6,
              label: 'Fashion & Accessories'
            },
            {
              value: 7,
              label: 'Souvenirs'
            },
            {
              value: 8,
              label: 'Watches & Electronics'
            },
            {
              value: 9,
              label: 'Others'
            }
          ]
        },
        {
          question: 'Future Duty Free Purchases',
          id: 1018,
          icon: 'las la-wallet',
          answers: [
            {
              value: 1,
              label: 'Less'
            },
            {
              value: 2,
              label: 'Same'
            },
            {
              value: 3,
              label: 'More'
            }
          ]
        }
      ],
      catalysts: [
        {
          question:
            'Cultural & Historical Experiences (Museums, cultural & historical sites)',
          id: 167,
          icon: 'las la-landmark'
        },
        {
          question: 'Opportunities for going to theme parks',
          id: 143,
          icon: 'las la-laugh-beam'
        },
        {
          question: 'Going to the beach',
          id: 137,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Shopping',
          id: 132,
          icon: 'las la-shopping-bag'
        },
        {
          question: 'Being active (Sport, adventure)',
          id: 148,
          icon: 'las la-running'
        },
        {
          question: 'Wellness/Spa',
          id: 139,
          icon: 'las la-spa'
        },
        {
          question: 'Nature/outdoor experiences',
          id: 133,
          icon: 'las la-mountain'
        },
        {
          question: 'Big city experiences',
          id: 150,
          icon: 'las la-city'
        },
        {
          question: 'Exciting food experience opportunities',
          id: 140,
          icon: 'las la-utensils'
        },
        {
          question: 'Fine dining',
          id: 141,
          icon: 'las la-concierge-bell'
        },
        {
          question:
            'Gaining a new skill/developing skill, e.g. language, cooking or similar',
          id: 138,
          icon: 'las la-sign-language'
        },
        {
          question: 'Interacting with locals',
          id: 153,
          icon: 'las la-language'
        },
        {
          question: 'All inclusive accommodation options',
          id: 158,
          icon: 'las la-wallet'
        },
        {
          question: 'Nightlife',
          id: 164,
          icon: 'las la-glass-cheers'
        },
        {
          question: 'Photography',
          id: 165,
          icon: 'las la-camera'
        }
      ],
      enablers: [
        {
          question: 'Price level in the country (affordability)',
          id: 127,
          icon: 'las la-hand-holding-usd'
        },
        {
          question: 'Environmental concerns and sustainability',
          id: 128,
          icon: 'las la-leaf'
        },
        {
          question: 'Safety standards/low crime levels',
          id: 129,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Cleanliness',
          id: 131,
          icon: 'las la-broom'
        },
        {
          question: 'Guided/Arranged tours/experiences',
          id: 149,
          icon: 'las la-users'
        },
        {
          question: 'Child friendliness',
          id: 130,
          icon: 'las la-baby-carriage'
        },
        {
          question: 'That the destination has few tourists',
          id: 142,
          icon: 'las la-user-alt-slash'
        },
        {
          question: 'Living new experiences',
          id: 151,
          icon: 'las la-fire-alt'
        },
        {
          question: 'Meeting new people',
          id: 152,
          icon: 'las la-user-friends'
        },
        {
          question: 'Easy access to health and medical facilities',
          id: 154,
          icon: 'las la-ambulance'
        },
        {
          question: 'Accessibility for less mobile',
          id: 155,
          icon: 'las la-wheelchair'
        },
        {
          question: 'LGBTQ+-friendly',
          id: 156,
          icon: 'las la-mercury'
        },
        {
          question: 'Direct flight',
          id: 159,
          icon: 'las la-plane'
        },
        {
          question: 'Flights from my local airport',
          id: 160,
          icon: 'las la-plane-departure'
        },
        {
          question: 'Being able to drive to the destination',
          id: 161,
          icon: 'las la-truck-pickup'
        },
        {
          question: 'Health and hygiene standards',
          id: 162,
          icon: 'las la-notes-medical'
        },
        {
          question: 'Pet friendly',
          id: 163,
          icon: 'las la-dog'
        },
        {
          question:
            'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
          id: 166,
          icon: 'las la-wallet'
        }
      ],
      plannings: [
        {
          question: 'Annual household holiday budget',
          id: 8,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: '0-1.000 EUR'
            },
            {
              value: 2,
              label: '1.000-2.999 EUR'
            },
            {
              value: 3,
              label: '3.000-4.999 EUR'
            },
            {
              value: 4,
              label: '5.000-9.999 EUR'
            },
            {
              value: 5,
              label: '10.000-19.999 EUR'
            },
            {
              value: 6,
              label: '20.000-29.999 EUR'
            },
            {
              value: 7,
              label: '30.000-39.999 EUR'
            },
            {
              value: 8,
              label: '40.000-49.999 EUR'
            },
            {
              value: 9,
              label: '50000 EUR or more'
            },
            {
              value: 10,
              label: 'Do not know/Do not want to state'
            }
          ]
        },
        {
          question: 'Budget compared to previous year',
          id: 9,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: 'Less than last year'
            },
            {
              value: 2,
              label: 'Same as last year'
            },
            {
              value: 3,
              label: 'More than last year'
            },
            {
              value: 4,
              label: 'Do not know'
            }
          ]
        },
        {
          question: 'Domestic Short holidays (up to 4 days)',
          id: 1274,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'Domestic Long holidays (5 days or more)',
          id: 1255,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Short holidays (up to 4 days)',
          id: 1254,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Long holidays (5 days or more)',
          id: 1265,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Short holidays (up to 4 days)',
          id: 1264,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Long holidays (5 days or more)',
          id: 1275,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Short holidays (up to 4 days)',
          id: 10,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Long holidays (5 days or more)',
          id: 11,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        }
      ],
      barriers: [
        {
          question: 'Political instability in destination',
          id: 1617,
          icon: 'las la-city'
        },
        {
          question: 'Political instability in my country',
          id: 1618,
          icon: 'las la-landmark'
        },
        {
          question: 'Threat of terrorist attack',
          id: 1619,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Global health concerns (covid, monkey pox)',
          id: 1620,
          icon: 'las la-heart'
        },
        {
          question: 'International conflicts',
          id: 1621,
          icon: 'las la-exclamation-triangle'
        },
        {
          question: 'Inconvenience in airports (delays/cancellations)',
          id: 1622,
          icon: 'las la-plane-arrival'
        },
        {
          question: 'Increase of cost of holidays',
          id: 1623,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Cost of living increase affecting disposable income',
          id: 1624,
          icon: 'las la-money-bill'
        },
        {
          question: 'Natural disasters or extreme weather at the destination',
          id: 1625,
          icon: 'las la-snowflake'
        }
      ]
    },
    filterOptions2022A: {
      ...defaultStructureFilter,
      demographics: [
        {
          question: 'Gender',
          id: 2,
          icon: 'las la-clone',
          answers: [
            {
              value: 1,
              label: 'Male'
            },
            {
              value: 2,
              label: 'Female'
            },
            {
              value: 3,
              label: 'Other'
            }
          ]
        },
        {
          question: 'Age',
          id: 3,
          icon: 'las la-birthday-cake',
          answers: [
            {
              value: '1',
              label: '18-24 years'
            },
            {
              value: '2',
              label: '25-34 years'
            },
            {
              value: '3',
              label: '35-44 years'
            },
            {
              value: '4',
              label: '45-54 years'
            },
            {
              value: '5',
              label: '55-64 years'
            },
            {
              value: '6',
              label: '65-74 years'
            },
            {
              value: '7',
              label: '75+ years'
            }
          ]
        },
        {
          question: 'Civil Status',
          id: 5,
          icon: 'las la-ring',
          answers: [
            {
              value: 1,
              label: 'Single'
            },
            {
              value: 2,
              label: 'In a relationship'
            },
            {
              value: 3,
              label: 'Co-habiting/Married'
            }
          ]
        },
        // {
        //   question: 'Age of children/shared children',
        //   id: 1006,
        //   icon: 'las la-child',
        //   answers: [
        //     {
        //       value: 1,
        //       label: 'Do not have children/Do not have children living at home'
        //     },
        //     {
        //       value: 2,
        //       label: '0-1 year'
        //     },
        //     {
        //       value: 3,
        //       label: '2 years'
        //     },
        //     {
        //       value: 4,
        //       label: '3 years'
        //     },
        //     {
        //       value: 5,
        //       label: '4 years'
        //     },
        //     {
        //       value: 6,
        //       label: '5 years'
        //     },
        //     {
        //       value: 7,
        //       label: '6 years'
        //     },
        //     {
        //       value: 8,
        //       label: '7 years'
        //     },
        //     {
        //       value: 9,
        //       label: '8 years'
        //     },
        //     {
        //       value: 10,
        //       label: '9 years'
        //     },
        //     {
        //       value: 11,
        //       label: '10 years'
        //     },
        //     {
        //       value: 12,
        //       label: '11 years'
        //     },
        //     {
        //       value: 13,
        //       label: '12 years'
        //     },
        //     {
        //       value: 14,
        //       label: '13 years'
        //     },
        //     {
        //       value: 15,
        //       label: '14 years'
        //     },
        //     {
        //       value: 16,
        //       label: '15 years'
        //     },
        //     {
        //       value: 17,
        //       label: '16 years'
        //     },
        //     {
        //       value: 18,
        //       label: '17 years'
        //     },
        //     {
        //       value: 19,
        //       label: '18 years+'
        //     }
        //   ]
        // },
        {
          question: 'Household Income',
          id: 6,
          icon: 'las la-wallet',
          answers: [
            {
              value: 1,
              label: 'Under 18.000 EUR'
            },
            {
              value: 2,
              label: '18.000 - 35.999 EUR'
            },
            {
              value: 3,
              label: '36.000 - 58.999 EUR'
            },
            {
              value: 4,
              label: '59.000 - 85.999 EUR'
            },
            {
              value: 5,
              label: '86.000 - 129.999 EUR'
            },
            {
              value: 6,
              label: '130.000 - 176.999 EUR'
            },
            {
              value: 7,
              label: '177.000 - 224.999 EUR'
            },
            {
              value: 8,
              label: 'Over 225.000 EUR'
            },
            {
              value: 9,
              label: 'Do not know/Do not want to state'
            }
          ]
        },
        {
          question: 'Education',
          id: 7,
          icon: 'las la-graduation-cap',
          answers: [
            {
              value: 1,
              label: 'School'
            },
            {
              value: 2,
              label: 'Vocational education'
            },
            {
              value: 3,
              label: 'Bachelors degree or similar'
            },
            {
              value: 4,
              label: 'Master degree or similar or above'
            }
          ]
        }
      ],
      behaviours: [
        {
          question: 'Preferred holiday type',
          id: 4022,
          icon: 'near_me',
          answers: [
            {
              value: 1,
              label: 'Sun and beach holiday'
            },
            {
              value: 2,
              label: 'Skiing holiday'
            },
            {
              value: 3,
              label:
                'Cultural holiday (where historical and cultural experiences are the main purpose)'
            },
            {
              value: 4,
              label: 'Cruise holiday'
            },
            {
              value: 5,
              label:
                'Multi destination tour (multiple locations/destinations in one holiday)'
            },
            {
              value: 6,
              label: 'Group holiday (min. 8 pax)'
            },
            {
              value: 7,
              label: 'Big city holiday'
            },
            {
              value: 8,
              label: 'Religious (Pilgrimage, practice religion)'
            },
            {
              value: 9,
              label:
                'Special occation travel, eg. Stag or hen party, anniversary or birthday celebration'
            },
            {
              value: 10,
              label:
                'Other Active holiday (hiking, sport, surfing, climbing, riding ect.)'
            },
            {
              value: 11,
              label: 'Volunteering as part of the holiday'
            },
            {
              value: 12,
              label: 'Birdwatching, Safari'
            },
            {
              value: 13,
              label: 'Wedding or honeymoon'
            },
            {
              value: 14,
              label: 'Attending festivals, events, sports events'
            },
            {
              value: 15,
              label: 'Visiting friends and family'
            },
            {
              value: 16,
              label: 'Gastronomic/culinary/wine experiences'
            },
            {
              value: 17,
              label: 'Relaxing (unwind, getting into a lower gear)'
            },
            {
              value: 18,
              label:
                'Doing something good for myself (wellness, retreat, yoga, spa)'
            },
            {
              value: 22,
              label: 'Golf holiday'
            },
            {
              value: 23,
              label: 'Diving holiday'
            },
            {
              value: 24,
              label:
                'Combining business and pleasure (extending business travel)'
            }
          ]
        },
        {
          question: 'Preferred type of accommodation',
          id: 4021,
          icon: 'luggage',
          answers: [
            {
              value: 1,
              label: 'Camping (caravan, autocamper, mobile home, tent)'
            },
            {
              value: 2,
              label: 'Glamping (luxury camping)'
            },
            {
              value: 3,
              label: 'Holiday home (not my own privately owned home)'
            },
            {
              value: 4,
              label: 'Private rental (e.g. Airbnb, Homeaway, house swap)'
            },
            {
              value: 5,
              label: 'My own private home at the destination'
            },
            {
              value: 6,
              label: 'Bed and Breakfast'
            },
            {
              value: 7,
              label: 'Budget Hotel/Hostel'
            },
            {
              value: 8,
              label: 'Farmhouse'
            },
            {
              value: 9,
              label: 'Traditional/ Historic property'
            },
            {
              value: 10,
              label: '3-4* Hotel'
            },
            {
              value: 11,
              label: 'Boutique Hotel'
            },
            {
              value: 12,
              label: 'City hotel'
            },
            {
              value: 13,
              label:
                'Globally recognised hotel brand (Hilton, Marriott, Sheraton, etc.)'
            },
            {
              value: 14,
              label: 'Resort'
            },
            {
              value: 15,
              label: 'Luxury Hotel (5+*)'
            },
            {
              value: 16,
              label: 'Spa hotel'
            },
            {
              value: 17,
              label: 'Contemporary style accommodation/design hotel'
            },
            {
              value: 18,
              label: 'Staying with friends or family'
            },
            {
              value: 21,
              label: 'Boating (house boat, yacht)'
            },
            {
              value: 22,
              label: 'Luxury suite/villa'
            },
            {
              value: 23,
              label: 'Cruise'
            }
          ]
        },
        {
          question: 'Inspiration',
          id: 16,
          icon: 'search',
          answers: [
            {
              value: 2,
              label: 'Facebook'
            },
            {
              value: 3,
              label: 'Instagram'
            },
            {
              value: 4,
              label: 'Snapchat'
            },
            {
              value: 5,
              label: 'Twitter'
            },
            {
              value: 6,
              label: 'Blogs'
            },
            {
              value: 7,
              label: 'Podcasts'
            },
            {
              value: 8,
              label: 'TikTok'
            },
            {
              value: 9,
              label: 'Youtube'
            },
            {
              value: 10,
              label: 'Online reviews sites (Tripadvisor, etc.)'
            },
            {
              value: 12,
              label: 'Online media'
            },
            {
              value: 13,
              label: 'Online lifestyle and travel magazines'
            },
            {
              value: 15,
              label: 'Influencers and celebrities'
            },
            {
              value: 20,
              label: 'Search engines (Google, Bing..)'
            },
            {
              value: 21,
              label: 'Online Travel Agencies'
            },
            {
              value: 22,
              label: 'Travel company websites (airline, hotels, etc.)'
            },
            {
              value: 24,
              label: 'Twitch'
            },
            {
              value: 25,
              label: 'Wechat'
            },
            {
              value: 26,
              label: 'Oficial tourism board / office website'
            }
          ]
        },
        {
          question: 'Inspiration Offline',
          id: 1016,
          icon: 'las la-search-location',
          answers: [
            {
              value: 1,
              label: 'Family & friends'
            },
            {
              value: 11,
              label: 'Newspapers and Supplements'
            },
            {
              value: 16,
              label: 'Cinema/movies'
            },
            {
              value: 17,
              label: 'TV advertising'
            },
            {
              value: 18,
              label: 'Travel TV programmes'
            },
            {
              value: 19,
              label: 'Radio'
            },
            {
              value: 27,
              label: 'Outdoor advertising'
            },
            {
              value: 28,
              label: 'Promotional Events'
            },
            {
              value: 29,
              label: 'Travel agency recommendation / Shop windows'
            },
            {
              value: 30,
              label: 'Lifestyle and travel print magazines'
            }
          ]
        },
        {
          question: 'Booking',
          id: 4020,
          icon: 'store',
          answers: [
            {
              value: 1,
              label:
                'Book package trip (flight+accommodation) online at travel agency website'
            },
            {
              value: 2,
              label:
                'Book package trip (flight+accommodation) with a travel agent in person or via phone/email'
            },
            {
              value: 3,
              label:
                'Book seperate flight and hotel online via different booking portals/travel agencies'
            },
            {
              value: 4,
              label:
                'Book package (flight and accommodation) direct with tour operator'
            },
            {
              value: 5,
              label:
                "Book accommodation directly via the accommodation's website"
            },
            {
              value: 6,
              label:
                'Book transportation directly via the airline/car rental/rail/coach/cruise website'
            },
            {
              value: 7,
              label:
                'Use price comparison site (e.g. Momondo, Trivago, Skyscanner)'
            }
          ]
        },
        {
          question: 'Transportation',
          id: 5019,
          icon: 'las la-car',
          answers: [
            {
              value: 1,
              label: 'Own vehicle'
            },
            {
              value: 2,
              label: 'Rental Car'
            },
            {
              value: 3,
              label: 'Bus'
            },
            {
              value: 4,
              label: 'Train'
            },
            {
              value: 5,
              label: 'Flight first class/business class'
            },
            {
              value: 6,
              label: 'Flight premium economy / economy'
            },
            {
              value: 7,
              label: 'Ferry'
            },
            {
              value: 8,
              label: 'Private boats (small cruices / yatching)'
            },
            {
              value: 9,
              label: 'Cruise'
            }
          ]
        },
        {
          question: 'Apprehension level',
          id: 1021,
          icon: 'las la-asterisk',
          answers: [
            {
              value: 1,
              label: 'Yes, definitely'
            },
            {
              value: 2,
              label: 'Yes, if I myself feel that it is safe'
            },
            {
              value: 3,
              label: 'Maybe if it is a really good offer'
            },
            {
              value: 4,
              label: 'No'
            }
          ]
        },
        {
          question: 'Duty Free Frequency',
          id: 1022,
          icon: 'las la-store',
          answers: [
            {
              value: 1,
              label: 'Never'
            },
            {
              value: 2,
              label: 'Rarely'
            },
            {
              value: 3,
              label: 'Often'
            },
            {
              value: 4,
              label: 'Always'
            }
          ]
        },
        {
          question: 'Duty Free Products',
          id: 1017,
          icon: 'las la-wine-bottle',
          answers: [
            {
              value: 1,
              label: 'Beauty'
            },
            {
              value: 2,
              label: 'Wine & Spirits'
            },
            {
              value: 3,
              label: 'Tobacco'
            },
            {
              value: 4,
              label: 'Confectionery'
            },
            {
              value: 5,
              label: 'Fine Food'
            },
            {
              value: 6,
              label: 'Fashion & Accessories'
            },
            {
              value: 7,
              label: 'Souvenirs'
            },
            {
              value: 8,
              label: 'Watches & Electronics'
            },
            {
              value: 9,
              label: 'Others'
            }
          ]
        },
        {
          question: 'Future Duty Free Purchases',
          id: 1018,
          icon: 'las la-wallet',
          answers: [
            {
              value: 1,
              label: 'Less'
            },
            {
              value: 2,
              label: 'Same'
            },
            {
              value: 3,
              label: 'More'
            }
          ]
        },
        {
          question: 'Social And Environmental Responsibility',
          id: 1019,
          icon: 'las la-dove',
          answers: [
            {
              value: 1,
              label: 'Compensated CO2 emissions'
            },
            {
              value: 2,
              label: 'Chosen a train or bus over a plane ticket'
            },
            {
              value: 3,
              label:
                'Taken part in a rural / local community experience to share their domestic life'
            },
            {
              value: 4,
              label: 'Supported a social conservation project (activism)'
            },
            {
              value: 5,
              label:
                'Supported a environmental / biodiversity conservation project (activism)'
            },
            {
              value: 6,
              label:
                'Chosen ecofriendly accommodation in spite of costing more than a regular one'
            },
            {
              value: 7,
              label: 'None of the above'
            }
          ]
        }
      ],
      catalysts: [
        {
          question:
            'Cultural & Historical Experiences (Museums, cultural & historical sites)',
          id: 167,
          icon: 'las la-landmark'
        },
        {
          question: 'Opportunities for going to theme parks',
          id: 143,
          icon: 'las la-laugh-beam'
        },
        {
          question: 'Going to the beach',
          id: 137,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Shopping',
          id: 132,
          icon: 'las la-shopping-bag'
        },
        {
          question: 'Being active (Sport, adventure)',
          id: 148,
          icon: 'las la-running'
        },
        {
          question: 'Wellness/Spa',
          id: 139,
          icon: 'las la-spa'
        },
        {
          question: 'Nature/outdoor experiences',
          id: 133,
          icon: 'las la-mountain'
        },
        {
          question: 'Big city experiences',
          id: 150,
          icon: 'las la-city'
        },
        {
          question: 'Exciting food experience opportunities',
          id: 140,
          icon: 'las la-utensils'
        },
        {
          question: 'Fine dining',
          id: 141,
          icon: 'las la-concierge-bell'
        },
        {
          question:
            'Gaining a new skill/developing skill, e.g. language, cooking or similar',
          id: 138,
          icon: 'las la-sign-language'
        },
        {
          question: 'Interacting with locals',
          id: 153,
          icon: 'las la-language'
        },
        {
          question: 'All inclusive accommodation options',
          id: 158,
          icon: 'las la-wallet'
        },
        {
          question: 'Nightlife',
          id: 164,
          icon: 'las la-glass-cheers'
        },
        {
          question: 'Photography',
          id: 165,
          icon: 'las la-camera'
        }
      ],
      enablers: [
        {
          question: 'Price level in the country (affordability)',
          id: 127,
          icon: 'las la-hand-holding-usd'
        },
        {
          question: 'Environmental concerns and sustainability',
          id: 128,
          icon: 'las la-leaf'
        },
        {
          question: 'Safety standards/low crime levels',
          id: 129,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Cleanliness',
          id: 131,
          icon: 'las la-broom'
        },
        {
          question: 'Guided/Arranged tours/experiences',
          id: 149,
          icon: 'las la-users'
        },
        {
          question: 'Child friendliness',
          id: 130,
          icon: 'las la-baby-carriage'
        },
        {
          question: 'That the destination has few tourists',
          id: 142,
          icon: 'las la-user-alt-slash'
        },
        {
          question: 'Living new experiences',
          id: 151,
          icon: 'las la-fire-alt'
        },
        {
          question: 'Meeting new people',
          id: 152,
          icon: 'las la-user-friends'
        },
        {
          question: 'Easy access to health and medical facilities',
          id: 154,
          icon: 'las la-ambulance'
        },
        {
          question: 'Accessibility for less mobile',
          id: 155,
          icon: 'las la-wheelchair'
        },
        {
          question: 'LGBTQ+-friendly',
          id: 156,
          icon: 'las la-mercury'
        },
        {
          question: 'Direct flight',
          id: 159,
          icon: 'las la-plane'
        },
        {
          question: 'Flights from my local airport',
          id: 160,
          icon: 'las la-plane-departure'
        },
        {
          question: 'Being able to drive to the destination',
          id: 161,
          icon: 'las la-truck-pickup'
        },
        {
          question: 'Health and hygiene standards',
          id: 162,
          icon: 'las la-notes-medical'
        },
        {
          question: 'Pet friendly',
          id: 163,
          icon: 'las la-dog'
        },
        {
          question:
            'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
          id: 166,
          icon: 'las la-wallet'
        }
      ],
      plannings: [
        {
          question: 'Annual household holiday budget',
          id: 8,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: '0-1.000 EUR'
            },
            {
              value: 2,
              label: '1.000-2.999 EUR'
            },
            {
              value: 3,
              label: '3.000-4.999 EUR'
            },
            {
              value: 4,
              label: '5.000-9.999 EUR'
            },
            {
              value: 5,
              label: '10.000-19.999 EUR'
            },
            {
              value: 6,
              label: '20.000-29.999 EUR'
            },
            {
              value: 7,
              label: '30.000-39.999 EUR'
            },
            {
              value: 8,
              label: '40.000-49.999 EUR'
            },
            {
              value: 9,
              label: '50000 EUR or more'
            },
            {
              value: 10,
              label: 'Do not know/Do not want to state'
            }
          ]
        },
        {
          question: 'Budget compared to previous year',
          id: 9,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: 'Less than last year'
            },
            {
              value: 2,
              label: 'Same as last year'
            },
            {
              value: 3,
              label: 'More than last year'
            },
            {
              value: 4,
              label: 'Do not know'
            }
          ]
        },
        {
          question: 'Domestic Short holidays (up to 4 days)',
          id: 1274,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'Domestic Long holidays (5 days or more)',
          id: 1255,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Short holidays (up to 4 days)',
          id: 1254,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Long holidays (5 days or more)',
          id: 1265,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Short holidays (up to 4 days)',
          id: 1264,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Long holidays (5 days or more)',
          id: 1275,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Short holidays (up to 4 days)',
          id: 10,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Long holidays (5 days or more)',
          id: 11,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        }
      ],
      barriers: [
        {
          question: 'Political instability in destination',
          id: 1617,
          icon: 'las la-city'
        },
        {
          question: 'Political instability in my country',
          id: 1618,
          icon: 'las la-landmark'
        },
        {
          question: 'Threat of terrorist attack',
          id: 1619,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Global health concerns (covid, monkey pox)',
          id: 1620,
          icon: 'las la-heart'
        },
        {
          question: 'International conflicts',
          id: 1621,
          icon: 'las la-exclamation-triangle'
        },
        {
          question: 'Inconvenience in airports (delays/cancellations)',
          id: 1622,
          icon: 'las la-plane-arrival'
        },
        {
          question: 'Increase of cost of holidays',
          id: 1623,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Cost of living increase affecting disposable income',
          id: 1624,
          icon: 'las la-money-bill'
        },
        {
          question: 'Natural disasters or extreme weather at the destination',
          id: 1625,
          icon: 'las la-snowflake'
        }
      ]
    },
    filterOptions2022B: {
      ...defaultStructureFilter,
      demographics: [
        {
          question: 'Gender',
          id: 2,
          icon: 'las la-clone',
          answers: [
            {
              value: 1,
              label: 'Male'
            },
            {
              value: 2,
              label: 'Female'
            },
            {
              value: 3,
              label: 'Other'
            }
          ]
        },
        {
          question: 'Age',
          id: 3,
          icon: 'las la-birthday-cake',
          answers: [
            {
              value: '1',
              label: '18-24 years'
            },
            {
              value: '2',
              label: '25-34 years'
            },
            {
              value: '3',
              label: '35-44 years'
            },
            {
              value: '4',
              label: '45-54 years'
            },
            {
              value: '5',
              label: '55-64 years'
            },
            {
              value: '6',
              label: '65-74 years'
            },
            {
              value: '7',
              label: '75+ years'
            }
          ]
        },
        {
          question: 'Civil Status',
          id: 5,
          icon: 'las la-ring',
          answers: [
            {
              value: 1,
              label: 'Single'
            },
            {
              value: 2,
              label: 'In a relationship'
            },
            {
              value: 3,
              label: 'Co-habiting/Married'
            }
          ]
        },
        // {
        //   question: 'Age of children/shared children',
        //   id: 1006,
        //   icon: 'las la-child',
        //   answers: [
        //     {
        //       value: 1,
        //       label: 'Do not have children/Do not have children living at home'
        //     },
        //     {
        //       value: 2,
        //       label: '0-1 year'
        //     },
        //     {
        //       value: 3,
        //       label: '2 years'
        //     },
        //     {
        //       value: 4,
        //       label: '3 years'
        //     },
        //     {
        //       value: 5,
        //       label: '4 years'
        //     },
        //     {
        //       value: 6,
        //       label: '5 years'
        //     },
        //     {
        //       value: 7,
        //       label: '6 years'
        //     },
        //     {
        //       value: 8,
        //       label: '7 years'
        //     },
        //     {
        //       value: 9,
        //       label: '8 years'
        //     },
        //     {
        //       value: 10,
        //       label: '9 years'
        //     },
        //     {
        //       value: 11,
        //       label: '10 years'
        //     },
        //     {
        //       value: 12,
        //       label: '11 years'
        //     },
        //     {
        //       value: 13,
        //       label: '12 years'
        //     },
        //     {
        //       value: 14,
        //       label: '13 years'
        //     },
        //     {
        //       value: 15,
        //       label: '14 years'
        //     },
        //     {
        //       value: 16,
        //       label: '15 years'
        //     },
        //     {
        //       value: 17,
        //       label: '16 years'
        //     },
        //     {
        //       value: 18,
        //       label: '17 years'
        //     },
        //     {
        //       value: 19,
        //       label: '18 years+'
        //     }
        //   ]
        // },
        {
          question: 'Household Income',
          id: 6,
          icon: 'las la-wallet',
          answers: [
            {
              value: 1,
              label: 'Under 18.000 EUR'
            },
            {
              value: 2,
              label: '18.000 - 35.999 EUR'
            },
            {
              value: 3,
              label: '36.000 - 58.999 EUR'
            },
            {
              value: 4,
              label: '59.000 - 85.999 EUR'
            },
            {
              value: 5,
              label: '86.000 - 129.999 EUR'
            },
            {
              value: 6,
              label: '130.000 - 176.999 EUR'
            },
            {
              value: 7,
              label: '177.000 - 224.999 EUR'
            },
            {
              value: 8,
              label: 'Over 225.000 EUR'
            },
            {
              value: 9,
              label: 'Do not know/Do not want to state'
            }
          ]
        },
        {
          question: 'Education',
          id: 7,
          icon: 'las la-graduation-cap',
          answers: [
            {
              value: 1,
              label: 'School'
            },
            {
              value: 2,
              label: 'Vocational education'
            },
            {
              value: 3,
              label: 'Bachelors degree or similar'
            },
            {
              value: 4,
              label: 'Master degree or similar or above'
            }
          ]
        }
      ],
      behaviours: [
        {
          question: 'Preferred holiday type',
          id: 4022,
          icon: 'near_me',
          answers: [
            {
              value: 1,
              label: 'Sun and beach holiday'
            },
            {
              value: 2,
              label: 'Skiing holiday'
            },
            {
              value: 3,
              label:
                'Cultural holiday (where historical and cultural experiences are the main purpose)'
            },
            {
              value: 4,
              label: 'Cruise holiday'
            },
            {
              value: 5,
              label:
                'Multi destination tour (multiple locations/destinations in one holiday)'
            },
            {
              value: 6,
              label: 'Group holiday (min. 8 pax)'
            },
            {
              value: 7,
              label: 'Big city holiday'
            },
            {
              value: 8,
              label: 'Religious (Pilgrimage, practice religion)'
            },
            {
              value: 9,
              label:
                'Special occation travel, eg. Stag or hen party, anniversary or birthday celebration'
            },
            {
              value: 10,
              label:
                'Other Active holiday (hiking, sport, surfing, climbing, riding ect.)'
            },
            {
              value: 11,
              label: 'Volunteering as part of the holiday'
            },
            {
              value: 12,
              label: 'Birdwatching, Safari'
            },
            {
              value: 13,
              label: 'Wedding or honeymoon'
            },
            {
              value: 25,
              label: 'Attending Festivals, cultural events'
            },
            {
              value: 26,
              label: 'Attending Sports events'
            },
            {
              value: 27,
              label:
                'Attending special interest events (tech, media, comics, innovation)'
            },
            {
              value: 15,
              label: 'Visiting friends and family'
            },
            {
              value: 16,
              label: 'Gastronomic/culinary/wine experiences'
            },
            {
              value: 17,
              label: 'Relaxing (unwind, getting into a lower gear)'
            },
            {
              value: 18,
              label:
                'Doing something good for myself (wellness, retreat, yoga, spa)'
            },
            {
              value: 22,
              label: 'Golf holiday'
            },
            {
              value: 23,
              label: 'Diving holiday'
            },
            {
              value: 24,
              label:
                'Combining business and pleasure (extending business travel)'
            },
            {
              value: 28,
              label: 'Study trips'
            },
            {
              value: 29,
              label:
                'Workation (travelling to a destination to work remotely from there)'
            }
          ]
        },
        {
          question: 'Preferred type of accommodation',
          id: 4021,
          icon: 'luggage',
          answers: [
            {
              value: 1,
              label: 'Camping (caravan, autocamper, mobile home, tent)'
            },
            {
              value: 2,
              label: 'Glamping (luxury camping)'
            },
            {
              value: 3,
              label: 'Holiday home (not my own privately owned home)'
            },
            {
              value: 4,
              label: 'Private rental (e.g. Airbnb, Homeaway, house swap)'
            },
            {
              value: 5,
              label: 'My own private home at the destination'
            },
            {
              value: 6,
              label: 'Bed and Breakfast'
            },
            {
              value: 7,
              label: 'Budget Hotel/Hostel'
            },
            {
              value: 8,
              label: 'Farmhouse'
            },
            {
              value: 9,
              label: 'Traditional/ Historic property'
            },
            {
              value: 10,
              label: '3-4* Hotel'
            },
            {
              value: 11,
              label: 'Boutique Hotel'
            },
            {
              value: 12,
              label: 'City hotel'
            },
            {
              value: 13,
              label:
                'Globally recognised hotel brand (Hilton, Marriott, Sheraton, etc.)'
            },
            {
              value: 14,
              label: 'Resort'
            },
            {
              value: 15,
              label: 'Luxury Hotel (5+*)'
            },
            {
              value: 16,
              label: 'Spa hotel'
            },
            {
              value: 17,
              label: 'Contemporary style accommodation/design hotel'
            },
            {
              value: 18,
              label: 'Staying with friends or family'
            },
            {
              value: 21,
              label: 'Boating (house boat, yacht)'
            },
            {
              value: 22,
              label: 'Luxury suite/villa'
            },
            {
              value: 23,
              label: 'Cruise'
            }
          ]
        },
        {
          question: 'Inspiration',
          id: 16,
          icon: 'search',
          answers: [
            {
              value: 2,
              label: 'Facebook'
            },
            {
              value: 3,
              label: 'Instagram'
            },
            {
              value: 4,
              label: 'Snapchat'
            },
            {
              value: 5,
              label: 'Twitter'
            },
            {
              value: 6,
              label: 'Blogs'
            },
            {
              value: 7,
              label: 'Podcasts'
            },
            {
              value: 8,
              label: 'TikTok'
            },
            {
              value: 9,
              label: 'Youtube'
            },
            {
              value: 10,
              label: 'Online reviews sites (Tripadvisor, etc.)'
            },
            {
              value: 12,
              label: 'Online media'
            },
            {
              value: 13,
              label: 'Online lifestyle and travel magazines'
            },
            {
              value: 15,
              label: 'Influencers and celebrities'
            },
            {
              value: 20,
              label: 'Search engines (Google, Bing..)'
            },
            {
              value: 21,
              label: 'Online Travel Agencies'
            },
            {
              value: 22,
              label: 'Travel company websites (airline, hotels, etc.)'
            },
            {
              value: 24,
              label: 'Twitch'
            },
            {
              value: 25,
              label: 'Wechat'
            },
            {
              value: 26,
              label: 'Oficial tourism board / office website'
            },
            {
              value: 27,
              label: 'Discord'
            },
            {
              value: 28,
              label: 'Whatsapp'
            }
          ]
        },
        {
          question: 'Inspiration Offline',
          id: 1016,
          icon: 'las la-search-location',
          answers: [
            {
              value: 1,
              label: 'Family & friends'
            },
            {
              value: 11,
              label: 'Newspapers and Supplements'
            },
            {
              value: 16,
              label: 'Cinema/movies'
            },
            {
              value: 17,
              label: 'TV advertising'
            },
            {
              value: 18,
              label: 'Travel TV programmes'
            },
            {
              value: 19,
              label: 'Radio'
            },
            {
              value: 27,
              label: 'Outdoor advertising'
            },
            {
              value: 28,
              label: 'Promotional Events'
            },
            {
              value: 29,
              label: 'Travel agency recommendation / Shop windows'
            },
            {
              value: 30,
              label: 'Lifestyle and travel print magazines'
            }
          ]
        },
        {
          question: 'Booking',
          id: 4020,
          icon: 'store',
          answers: [
            {
              value: 1,
              label:
                'Book package trip (flight+accommodation) online at travel agency website'
            },
            {
              value: 2,
              label:
                'Book package trip (flight+accommodation) with a travel agent in person or via phone/email'
            },
            {
              value: 3,
              label:
                'Book seperate flight and hotel online via different booking portals/travel agencies'
            },
            {
              value: 4,
              label:
                'Book package (flight and accommodation) direct with tour operator'
            },
            {
              value: 5,
              label:
                "Book accommodation directly via the accommodation's website"
            },
            {
              value: 6,
              label:
                'Book transportation directly via the airline/car rental/rail/coach/cruise website'
            },
            {
              value: 7,
              label:
                'Use price comparison site (e.g. Momondo, Trivago, Skyscanner)'
            }
          ]
        },
        {
          question: 'Transportation',
          id: 5019,
          icon: 'las la-car',
          answers: [
            {
              value: 1,
              label: 'Own vehicle'
            },
            {
              value: 2,
              label: 'Rental Car'
            },
            {
              value: 3,
              label: 'Bus'
            },
            {
              value: 4,
              label: 'Train'
            },
            {
              value: 5,
              label: 'Flight first class/business class'
            },
            {
              value: 6,
              label: 'Flight premium economy / economy'
            },
            {
              value: 7,
              label: 'Ferry'
            },
            {
              value: 8,
              label: 'Private boats (small cruices / yatching)'
            },
            {
              value: 9,
              label: 'Cruise'
            }
          ]
        },
        {
          question: 'Apprehension level',
          id: 1021,
          icon: 'las la-asterisk',
          answers: [
            {
              value: 1,
              label: 'Yes, definitely'
            },
            {
              value: 2,
              label: 'Yes, if I myself feel that it is safe'
            },
            {
              value: 3,
              label: 'Maybe if it is a really good offer'
            },
            {
              value: 4,
              label: 'No'
            }
          ]
        },
        {
          question: 'Social And Environmental Responsibility',
          id: 1019,
          icon: 'las la-dove',
          answers: [
            {
              value: 1,
              label: 'Compensated CO2 emissions'
            },
            {
              value: 2,
              label: 'Chosen a train or bus over a plane ticket'
            },
            {
              value: 3,
              label:
                'Taken part in a rural / local community experience to share their domestic life'
            },
            {
              value: 4,
              label: 'Supported a social conservation project (activism)'
            },
            {
              value: 5,
              label:
                'Supported a environmental / biodiversity conservation project (activism)'
            },
            {
              value: 6,
              label:
                'Chosen ecofriendly accommodation in spite of costing more than a regular one'
            },
            {
              value: 7,
              label: 'None of the above'
            }
          ]
        }
      ],
      catalysts: [
        {
          question:
            'Cultural & Historical Experiences (Museums, cultural & historical sites)',
          id: 167,
          icon: 'las la-landmark'
        },
        {
          question: 'Opportunities for going to theme parks',
          id: 143,
          icon: 'las la-laugh-beam'
        },
        {
          question: 'Going to the beach',
          id: 137,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Shopping',
          id: 132,
          icon: 'las la-shopping-bag'
        },
        {
          question: 'Being active (Sport, adventure)',
          id: 148,
          icon: 'las la-running'
        },
        {
          question: 'Wellness/Spa',
          id: 139,
          icon: 'las la-spa'
        },
        {
          question: 'Nature/outdoor experiences',
          id: 133,
          icon: 'las la-mountain'
        },
        {
          question: 'Big city experiences',
          id: 150,
          icon: 'las la-city'
        },
        {
          question: 'Exciting food experience opportunities',
          id: 140,
          icon: 'las la-utensils'
        },
        {
          question: 'Fine dining',
          id: 141,
          icon: 'las la-concierge-bell'
        },
        {
          question:
            'Gaining a new skill/developing skill, e.g. language, cooking or similar',
          id: 138,
          icon: 'las la-sign-language'
        },
        {
          question: 'Interacting with locals',
          id: 153,
          icon: 'las la-language'
        },
        {
          question: 'All inclusive accommodation options',
          id: 158,
          icon: 'las la-wallet'
        },
        {
          question: 'Nightlife',
          id: 164,
          icon: 'las la-glass-cheers'
        },
        {
          question: 'Photography',
          id: 165,
          icon: 'las la-camera'
        },
        {
          question:
            'Agenda of Sport Events (Football World cup / Regional tournaments / Wimbledon / Olympics / Formula1)',
          id: 168,
          icon: 'las la-basketball-ball'
        },
        {
          question: 'Agenda of Festivals, Concerts & Events',
          id: 169,
          icon: 'las la-theater-masks'
        }
      ],
      enablers: [
        {
          question: 'Price level in the country (affordability)',
          id: 127,
          icon: 'las la-hand-holding-usd'
        },
        {
          question: 'Environmental concerns and sustainability',
          id: 128,
          icon: 'las la-leaf'
        },
        {
          question: 'Safety standards/low crime levels',
          id: 129,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Cleanliness',
          id: 131,
          icon: 'las la-broom'
        },
        {
          question: 'Guided/Arranged tours/experiences',
          id: 149,
          icon: 'las la-users'
        },
        {
          question: 'Child friendliness',
          id: 130,
          icon: 'las la-baby-carriage'
        },
        {
          question: 'That the destination has few tourists',
          id: 142,
          icon: 'las la-user-alt-slash'
        },
        {
          question: 'Living new experiences',
          id: 151,
          icon: 'las la-fire-alt'
        },
        {
          question: 'Meeting new people',
          id: 152,
          icon: 'las la-user-friends'
        },
        {
          question: 'Easy access to health and medical facilities',
          id: 154,
          icon: 'las la-ambulance'
        },
        {
          question: 'Accessibility for less mobile',
          id: 155,
          icon: 'las la-wheelchair'
        },
        {
          question: 'LGBTQ+-friendly',
          id: 156,
          icon: 'las la-mercury'
        },
        {
          question: 'Direct flight',
          id: 159,
          icon: 'las la-plane'
        },
        {
          question: 'Flights from my local airport',
          id: 160,
          icon: 'las la-plane-departure'
        },
        {
          question: 'Being able to drive to the destination',
          id: 161,
          icon: 'las la-truck-pickup'
        },
        {
          question: 'Health and hygiene standards',
          id: 162,
          icon: 'las la-notes-medical'
        },
        {
          question: 'Pet friendly',
          id: 163,
          icon: 'las la-dog'
        },
        {
          question:
            'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
          id: 166,
          icon: 'las la-wallet'
        }
      ],
      plannings: [
        {
          question: 'Annual household holiday budget',
          id: 8,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: '0-1.000 EUR'
            },
            {
              value: 2,
              label: '1.000-2.999 EUR'
            },
            {
              value: 3,
              label: '3.000-4.999 EUR'
            },
            {
              value: 4,
              label: '5.000-9.999 EUR'
            },
            {
              value: 5,
              label: '10.000-19.999 EUR'
            },
            {
              value: 6,
              label: '20.000-29.999 EUR'
            },
            {
              value: 7,
              label: '30.000-39.999 EUR'
            },
            {
              value: 8,
              label: '40.000-49.999 EUR'
            },
            {
              value: 9,
              label: '50000 EUR or more'
            },
            {
              value: 10,
              label: 'Do not know/Do not want to state'
            }
          ]
        },
        {
          question: 'Budget compared to previous year',
          id: 9,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: 'Less than last year'
            },
            {
              value: 2,
              label: 'Same as last year'
            },
            {
              value: 3,
              label: 'More than last year'
            },
            {
              value: 4,
              label: 'Do not know'
            }
          ]
        },
        {
          question: 'Domestic Short holidays (up to 4 days)',
          id: 1274,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'Domestic Long holidays (5 days or more)',
          id: 1255,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Short holidays (up to 4 days)',
          id: 1254,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Long holidays (5 days or more)',
          id: 1265,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Short holidays (up to 4 days)',
          id: 1264,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Long holidays (5 days or more)',
          id: 1275,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Short holidays (up to 4 days)',
          id: 1164,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Long holidays (5 days or more)',
          id: 1165,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question:
            'International outside Europe Short holidays (up to 4 days)',
          id: 1154,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question:
            'International outside Europe Long holidays (5 days or more)',
          id: 1155,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        }
      ],
      barriers: [
        {
          question: 'Political instability in destination',
          id: 1617,
          icon: 'las la-city'
        },
        {
          question: 'Political instability in my country',
          id: 1618,
          icon: 'las la-landmark'
        },
        {
          question: 'Threat of terrorist attack',
          id: 1619,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Global health concerns (covid, monkey pox)',
          id: 1620,
          icon: 'las la-heart'
        },
        {
          question: 'International conflicts',
          id: 1621,
          icon: 'las la-exclamation-triangle'
        },
        {
          question: 'Inconvenience in airports (delays/cancellations)',
          id: 1622,
          icon: 'las la-plane-arrival'
        },
        {
          question: 'Increase of cost of holidays',
          id: 1623,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Cost of living increase affecting disposable income',
          id: 1624,
          icon: 'las la-money-bill'
        },
        {
          question: 'Natural disasters or extreme weather at the destination',
          id: 1625,
          icon: 'las la-snowflake'
        }
      ]
    },
    filterOptions2023: {
      ...defaultStructureFilter,
      demographics: [
        {
          question: 'Gender',
          id: 2,
          icon: 'las la-clone',
          answers: [
            {
              value: 1,
              label: 'Male'
            },
            {
              value: 2,
              label: 'Female'
            },
            {
              value: 3,
              label: 'Other'
            }
          ]
        },
        {
          question: 'Age',
          id: 3,
          icon: 'las la-birthday-cake',
          answers: [
            {
              value: '1',
              label: '18-24 years'
            },
            {
              value: '2',
              label: '25-34 years'
            },
            {
              value: '3',
              label: '35-44 years'
            },
            {
              value: '4',
              label: '45-54 years'
            },
            {
              value: '5',
              label: '55-64 years'
            },
            {
              value: '6',
              label: '65-74 years'
            },
            {
              value: '7',
              label: '75+ years'
            }
          ]
        },
        {
          question: 'Civil Status',
          id: 5,
          icon: 'las la-ring',
          answers: [
            {
              value: 1,
              label: 'Single'
            },
            {
              value: 2,
              label: 'In a relationship'
            },
            {
              value: 3,
              label: 'Co-habiting/Married'
            }
          ]
        },
        // {
        //   question: 'Age of children/shared children',
        //   id: 1006,
        //   icon: 'las la-child',
        //   answers: [
        //     {
        //       value: 1,
        //       label: 'Do not have children/Do not have children living at home'
        //     },
        //     {
        //       value: 2,
        //       label: '0-1 year'
        //     },
        //     {
        //       value: 3,
        //       label: '2 years'
        //     },
        //     {
        //       value: 4,
        //       label: '3 years'
        //     },
        //     {
        //       value: 5,
        //       label: '4 years'
        //     },
        //     {
        //       value: 6,
        //       label: '5 years'
        //     },
        //     {
        //       value: 7,
        //       label: '6 years'
        //     },
        //     {
        //       value: 8,
        //       label: '7 years'
        //     },
        //     {
        //       value: 9,
        //       label: '8 years'
        //     },
        //     {
        //       value: 10,
        //       label: '9 years'
        //     },
        //     {
        //       value: 11,
        //       label: '10 years'
        //     },
        //     {
        //       value: 12,
        //       label: '11 years'
        //     },
        //     {
        //       value: 13,
        //       label: '12 years'
        //     },
        //     {
        //       value: 14,
        //       label: '13 years'
        //     },
        //     {
        //       value: 15,
        //       label: '14 years'
        //     },
        //     {
        //       value: 16,
        //       label: '15 years'
        //     },
        //     {
        //       value: 17,
        //       label: '16 years'
        //     },
        //     {
        //       value: 18,
        //       label: '17 years'
        //     },
        //     {
        //       value: 19,
        //       label: '18 years+'
        //     }
        //   ]
        // },
        // {
        //   question: 'Household Income',
        //   id: 6,
        //   icon: 'las la-wallet',
        //   answers: [
        //     {
        //       value: 1,
        //       label: 'Under 18.000 EUR'
        //     },
        //     {
        //       value: 2,
        //       label: '18.000 - 35.999 EUR'
        //     },
        //     {
        //       value: 3,
        //       label: '36.000 - 58.999 EUR'
        //     },
        //     {
        //       value: 4,
        //       label: '59.000 - 85.999 EUR'
        //     },
        //     {
        //       value: 5,
        //       label: '86.000 - 129.999 EUR'
        //     },
        //     {
        //       value: 6,
        //       label: '130.000 - 176.999 EUR'
        //     },
        //     {
        //       value: 7,
        //       label: '177.000 - 224.999 EUR'
        //     },
        //     {
        //       value: 8,
        //       label: 'Over 225.000 EUR'
        //     },
        //     {
        //       value: 9,
        //       label: 'Do not know/Do not want to state'
        //     }
        //   ]
        // },
        {
          question: 'Education',
          id: 7,
          icon: 'las la-graduation-cap',
          answers: [
            {
              value: 1,
              label: 'School'
            },
            {
              value: 2,
              label: 'Vocational education'
            },
            {
              value: 3,
              label: 'Bachelors degree or similar'
            },
            {
              value: 4,
              label: 'Master degree or similar or above'
            }
          ]
        }
      ],
      behaviours: [
        {
          question: 'Preferred holiday type',
          id: 4022,
          icon: 'near_me',
          answers: [
            {
              value: 1,
              label: 'Sun and beach holiday'
            },
            {
              value: 2,
              label: 'Skiing holiday'
            },
            {
              value: 3,
              label:
                'Cultural holiday (where historical and cultural experiences are the main purpose)'
            },
            {
              value: 4,
              label: 'Cruise holiday'
            },
            {
              value: 5,
              label:
                'Multi destination tour (multiple locations/destinations in one holiday)'
            },
            {
              value: 6,
              label: 'Group holiday (min. 8 pax)'
            },
            {
              value: 7,
              label: 'Big city holiday'
            },
            {
              value: 8,
              label: 'Religious (Pilgrimage, practice religion)'
            },
            {
              value: 9,
              label:
                'Special occation travel, eg. Stag or hen party, anniversary or birthday celebration'
            },
            {
              value: 11,
              label: 'Volunteering as part of the holiday'
            },
            {
              value: 12,
              label: 'Birdwatching, Safari'
            },
            {
              value: 13,
              label: 'Wedding or honeymoon'
            },
            {
              value: 25,
              label: 'Attending Festivals, cultural events'
            },
            {
              value: 26,
              label: 'Attending Sports events'
            },
            {
              value: 27,
              label:
                'Attending special interest events (tech, media, comics, innovation)'
            },
            {
              value: 15,
              label: 'Visiting friends and family'
            },
            {
              value: 16,
              label: 'Gastronomic/culinary/wine experiences'
            },
            {
              value: 17,
              label: 'Relaxing (unwind, getting into a lower gear)'
            },
            {
              value: 18,
              label:
                'Doing something good for myself (wellness, retreat, yoga, spa)'
            },
            {
              value: 22,
              label: 'Golf holiday'
            },
            {
              value: 23,
              label: 'Diving holiday'
            },
            {
              value: 24,
              label:
                'Combining business and pleasure (extending business travel)'
            },
            {
              value: 28,
              label: 'Study trips'
            },
            {
              value: 29,
              label:
                'Workation (travelling to a destination to work remotely from there)'
            },
            {
              value: 30,
              label: 'Hiking/trekking holiday'
            },
            {
              value: 31,
              label: 'Cycling holiday (MTB and road cycling)'
            },
            {
              value: 32,
              label: 'Other active holiday (Climbing, riding etc.)'
            },
            {
              value: 33,
              label:
                'Health related travel,  eg. traveling for the purpose of having an hair transplan'
            }
          ]
        },
        {
          question: 'Preferred type of accommodation',
          id: 4021,
          icon: 'luggage',
          answers: [
            {
              value: 1,
              label: 'Camping (caravan, autocamper, mobile home, tent)'
            },
            {
              value: 2,
              label: 'Glamping (luxury camping)'
            },
            {
              value: 3,
              label: 'Holiday home (not my own privately owned home)'
            },
            {
              value: 4,
              label: 'Private rental (e.g. Airbnb, Homeaway, house swap)'
            },
            {
              value: 5,
              label: 'My own private home at the destination'
            },
            {
              value: 6,
              label: 'Bed and Breakfast'
            },
            {
              value: 7,
              label: 'Budget Hotel/Hostel'
            },
            {
              value: 8,
              label: 'Farmhouse'
            },
            {
              value: 9,
              label: 'Traditional/ Historic property'
            },
            {
              value: 10,
              label: '3-4* Hotel'
            },
            {
              value: 11,
              label: 'Boutique Hotel'
            },
            {
              value: 12,
              label: 'City hotel'
            },
            {
              value: 13,
              label:
                'Globally recognised hotel brand (Hilton, Marriott, Sheraton, etc.)'
            },
            {
              value: 14,
              label: 'Resort'
            },
            {
              value: 15,
              label: 'Luxury Hotel (5+*)'
            },
            {
              value: 16,
              label: 'Spa hotel'
            },
            {
              value: 17,
              label: 'Contemporary style accommodation/design hotel'
            },
            {
              value: 18,
              label: 'Staying with friends or family'
            },
            {
              value: 21,
              label: 'Boating (house boat, yacht)'
            },
            {
              value: 22,
              label: 'Luxury suite/villa'
            },
            {
              value: 23,
              label: 'Cruise'
            }
          ]
        },
        {
          question: 'Online Inspiration',
          id: 16,
          icon: 'search',
          answers: [
            {
              value: 2,
              label: 'Facebook'
            },
            {
              value: 3,
              label: 'Instagram'
            },
            {
              value: 4,
              label: 'Snapchat'
            },
            {
              value: 5,
              label: 'Twitter'
            },
            {
              value: 6,
              label: 'Blogs'
            },
            {
              value: 7,
              label: 'Podcasts'
            },
            {
              value: 8,
              label: 'TikTok'
            },
            {
              value: 9,
              label: 'Youtube'
            },
            {
              value: 10,
              label: 'Online reviews sites (Tripadvisor, etc.)'
            },
            {
              value: 12,
              label: 'Online media'
            },
            {
              value: 13,
              label: 'Online lifestyle and travel magazines'
            },
            {
              value: 15,
              label: 'Influencers and celebrities'
            },
            {
              value: 20,
              label: 'Search engines (Google, Bing..)'
            },
            {
              value: 21,
              label: 'Online Travel Agencies'
            },
            {
              value: 22,
              label: 'Travel company websites (airline, hotels, etc.)'
            },
            {
              value: 24,
              label: 'Twitch'
            },
            {
              value: 25,
              label: 'Wechat'
            },
            {
              value: 26,
              label: 'Oficial tourism board / office website'
            },
            {
              value: 27,
              label: 'Discord'
            },
            {
              value: 28,
              label: 'Whatsapp'
            }
          ]
        },
        {
          question: 'Inspiration Offline',
          id: 1016,
          icon: 'las la-search-location',
          answers: [
            {
              value: 1,
              label: 'Family & friends'
            },
            {
              value: 11,
              label: 'Newspapers and Supplements'
            },
            {
              value: 16,
              label: 'Cinema/movies'
            },
            {
              value: 17,
              label: 'TV advertising'
            },
            {
              value: 18,
              label: 'Travel TV programmes'
            },
            {
              value: 19,
              label: 'Radio'
            },
            {
              value: 27,
              label: 'Outdoor advertising'
            },
            {
              value: 28,
              label: 'Promotional Events'
            },
            {
              value: 29,
              label: 'Travel agency recommendation / Shop windows'
            },
            {
              value: 30,
              label: 'Lifestyle and travel print magazines'
            }
          ]
        },
        {
          question: 'Booking',
          id: 4020,
          icon: 'store',
          answers: [
            {
              value: 1,
              label:
                'Book package trip (flight+accommodation) online at travel agency website'
            },
            {
              value: 2,
              label:
                'Book package trip (flight+accommodation) with a travel agent in person or via phone/email'
            },
            {
              value: 3,
              label:
                'Book seperate flight and hotel online via different booking portals/travel agencies'
            },
            {
              value: 4,
              label:
                'Book package (flight and accommodation) direct with tour operator'
            },
            {
              value: 5,
              label:
                "Book accommodation directly via the accommodation's website"
            },
            {
              value: 6,
              label:
                'Book transportation directly via the airline/car rental/rail/coach/cruise website'
            },
            {
              value: 7,
              label:
                'Use price comparison site (e.g. Momondo, Trivago, Skyscanner)'
            }
          ]
        },
        {
          question: 'Transportation',
          id: 5019,
          icon: 'las la-car',
          answers: [
            {
              value: 1,
              label: 'Own vehicle'
            },
            {
              value: 2,
              label: 'Rental Car'
            },
            {
              value: 3,
              label: 'Bus'
            },
            {
              value: 4,
              label: 'Train'
            },
            {
              value: 5,
              label: 'Flight first class/business class'
            },
            {
              value: 6,
              label: 'Flight premium economy / economy'
            },
            {
              value: 7,
              label: 'Ferry'
            },
            {
              value: 8,
              label: 'Private boats (small cruices / yatching)'
            },
            {
              value: 9,
              label: 'Cruise'
            }
          ]
        },
        {
          question: 'Apprehension level',
          id: 1021,
          icon: 'las la-asterisk',
          answers: [
            {
              value: 1,
              label: 'Yes, definitely'
            },
            {
              value: 2,
              label: 'Yes, if I myself feel that it is safe'
            },
            {
              value: 3,
              label: 'Maybe if it is a really good offer'
            },
            {
              value: 4,
              label: 'No'
            }
          ]
        },
        {
          question: 'Social And Environmental Responsibility',
          id: 1019,
          icon: 'las la-dove',
          answers: [
            {
              value: 1,
              label: 'Compensated CO2 emissions'
            },
            {
              value: 2,
              label: 'Chosen a train or bus over a plane ticket'
            },
            {
              value: 3,
              label:
                'Taken part in a rural / local community experience to share their domestic life'
            },
            {
              value: 4,
              label: 'Supported a social conservation project (activism)'
            },
            {
              value: 5,
              label:
                'Supported a environmental / biodiversity conservation project (activism)'
            },
            {
              value: 6,
              label:
                'Chosen ecofriendly accommodation in spite of costing more than a regular one'
            },
            {
              value: 7,
              label: 'None of the above'
            }
          ]
        }
      ],
      catalysts: [
        {
          question:
            'Cultural & Historical Experiences (Museums, cultural & historical sites)',
          id: 167,
          icon: 'las la-landmark'
        },
        {
          question: 'Opportunities for going to theme parks',
          id: 143,
          icon: 'las la-laugh-beam'
        },
        {
          question: 'Going to the beach',
          id: 137,
          icon: 'las la-umbrella-beach'
        },
        { question: 'Shopping', id: 132, icon: 'las la-shopping-bag' },
        {
          question: 'Being active (Sport, adventure)',
          id: 148,
          icon: 'las la-running'
        },
        { question: 'Wellness/Spa', id: 139, icon: 'las la-spa' },
        {
          question: 'Nature/outdoor experiences',
          id: 133,
          icon: 'las la-mountain'
        },
        { question: 'Big city experiences', id: 150, icon: 'las la-city' },
        { question: 'Food experiences', id: 140, icon: 'las la-utensils' },
        { question: 'Fine dining', id: 141, icon: 'las la-concierge-bell' },
        {
          question:
            'Gaining a new skill/developing skill, e.g. language, cooking or similar',
          id: 138,
          icon: 'las la-sign-language'
        },
        {
          question: 'Interacting with locals',
          id: 153,
          icon: 'las la-language'
        },
        {
          question: 'All inclusive accommodation options',
          id: 158,
          icon: 'las la-wallet'
        },
        { question: 'Nightlife', id: 164, icon: 'las la-glass-cheers' },
        { question: 'Photography', id: 165, icon: 'las la-camera' },

        {
          question:
            'Agenda of Sport Events (Football World cup / Regional tournaments / Wimbledon / Olympics / Formula1)',
          id: 168,
          icon: 'las la-basketball-ball'
        },
        {
          question: 'Agenda of Festivals, Concerts & Events',
          id: 169,
          icon: 'las la-theater-masks'
        }
      ],
      enablers: [
        {
          question: 'Price level in the country (affordability)',
          id: 127,
          icon: 'las la-hand-holding-usd'
        },
        {
          question: 'Environmental concerns and sustainability',
          id: 128,
          icon: 'las la-leaf'
        },
        {
          question: 'Safety standards/low crime levels',
          id: 129,
          icon: 'las la-shield-alt'
        },
        { question: 'Cleanliness', id: 131, icon: 'las la-broom' },
        {
          question: 'Guided/Arranged tours/experiences',
          id: 149,
          icon: 'las la-users'
        },
        {
          question: 'Child friendliness',
          id: 130,
          icon: 'las la-baby-carriage'
        },
        {
          question: 'That the destination has few tourists',
          id: 142,
          icon: 'las la-user-alt-slash'
        },
        {
          question: 'Living new experiences',
          id: 151,
          icon: 'las la-fire-alt'
        },
        {
          question: 'Meeting new people',
          id: 152,
          icon: 'las la-user-friends'
        },
        {
          question: 'Easy access to health and medical facilities',
          id: 154,
          icon: 'las la-ambulance'
        },
        {
          question: 'Accessibility for less mobile',
          id: 155,
          icon: 'las la-wheelchair'
        },
        {
          question: 'LGBTQ+- friendliness',
          id: 156,
          icon: 'las la-mercury'
        },
        {
          question: 'Direct flight',
          id: 159,
          icon: 'las la-plane'
        },
        {
          question: 'Flights from my local airport',
          id: 160,
          icon: 'las la-plane-departure'
        },
        {
          question: 'Being able to drive to the destination',
          id: 161,
          icon: 'las la-truck-pickup'
        },
        {
          question: 'Health and hygiene standards',
          id: 162,
          icon: 'las la-notes-medical'
        },
        {
          question: 'Pet friendliness',
          id: 163,
          icon: 'las la-dog'
        },
        {
          question:
            'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
          id: 166,
          icon: 'las la-wallet'
        },
        {
          question: 'Backpacker friendliness',
          id: 170,
          icon: 'backpack'
        }
      ],
      plannings: [
        {
          question: 'Annual household holiday budget',
          id: 8,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: '0-1.000 EUR'
            },
            {
              value: 2,
              label: '1.000-2.999 EUR'
            },
            {
              value: 3,
              label: '3.000-4.999 EUR'
            },
            {
              value: 4,
              label: '5.000-9.999 EUR'
            },
            {
              value: 5,
              label: '10.000-19.999 EUR'
            },
            {
              value: 6,
              label: '20.000-29.999 EUR'
            },
            {
              value: 7,
              label: '30.000-39.999 EUR'
            },
            {
              value: 8,
              label: '40.000-49.999 EUR'
            },
            {
              value: 9,
              label: '50000 EUR or more'
            },
            {
              value: 10,
              label: 'Do not know/Do not want to state'
            }
          ]
        },
        {
          question: 'Budget compared to previous year',
          id: 9,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: 'Less than last year'
            },
            {
              value: 2,
              label: 'Same as last year'
            },
            {
              value: 3,
              label: 'More than last year'
            },
            {
              value: 4,
              label: 'Do not know'
            }
          ]
        },
        {
          question: 'Domestic Short holidays (up to 4 days)',
          id: 1274,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'Domestic Long holidays (5 days or more)',
          id: 1255,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Short holidays (up to 4 days)',
          id: 1254,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Long holidays (5 days or more)',
          id: 1265,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Short holidays (up to 4 days)',
          id: 1264,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Long holidays (5 days or more)',
          id: 1275,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Short holidays (up to 4 days)',
          id: 1164,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Long holidays (5 days or more)',
          id: 1165,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question:
            'International outside Europe Short holidays (up to 4 days)',
          id: 1154,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question:
            'International outside Europe Long holidays (5 days or more)',
          id: 1155,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        }
      ],
      barriers: [
        {
          question: 'Political instability in destination',
          id: 1617,
          icon: 'las la-city'
        },
        {
          question: 'Political instability in my country',
          id: 1618,
          icon: 'las la-landmark'
        },
        {
          question: 'Threat of terrorist attack',
          id: 1619,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Global health concerns (covid, monkey pox)',
          id: 1620,
          icon: 'las la-heart'
        },
        {
          question: 'International conflicts',
          id: 1621,
          icon: 'las la-exclamation-triangle'
        },
        {
          question: 'Inconvenience in airports (delays/cancellations)',
          id: 1622,
          icon: 'las la-plane-arrival'
        },
        {
          question: 'Increase of cost of holidays',
          id: 1623,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Cost of living increase affecting disposable income',
          id: 1624,
          icon: 'las la-money-bill'
        },
        {
          question: 'Natural disasters or extreme weather at the destination',
          id: 1625,
          icon: 'las la-snowflake'
        }
      ]
    },
    filterOptions2023B: {
      ...defaultStructureFilter,
      demographics: [
        {
          question: 'Gender',
          id: 2,
          icon: 'las la-clone',
          answers: [
            {
              value: 1,
              label: 'Male'
            },
            {
              value: 2,
              label: 'Female'
            },
            {
              value: 3,
              label: 'Other'
            }
          ]
        },
        {
          question: 'Age',
          id: 3,
          icon: 'las la-birthday-cake',
          answers: [
            {
              value: '1',
              label: '18-24 years'
            },
            {
              value: '2',
              label: '25-34 years'
            },
            {
              value: '3',
              label: '35-44 years'
            },
            {
              value: '4',
              label: '45-54 years'
            },
            {
              value: '5',
              label: '55-64 years'
            },
            {
              value: '6',
              label: '65-74 years'
            },
            {
              value: '7',
              label: '75+ years'
            }
          ]
        },
        {
          question: 'Civil Status',
          id: 5,
          icon: 'las la-ring',
          answers: [
            {
              value: 1,
              label: 'Single'
            },
            {
              value: 2,
              label: 'In a relationship'
            },
            {
              value: 3,
              label: 'Co-habiting/Married'
            }
          ]
        },
        // {
        //   question: 'Age of children/shared children',
        //   id: 1006,
        //   icon: 'las la-child',
        //   answers: [
        //     {
        //       value: 1,
        //       label: 'Do not have children/Do not have children living at home'
        //     },
        //     {
        //       value: 2,
        //       label: '0-1 year'
        //     },
        //     {
        //       value: 3,
        //       label: '2 years'
        //     },
        //     {
        //       value: 4,
        //       label: '3 years'
        //     },
        //     {
        //       value: 5,
        //       label: '4 years'
        //     },
        //     {
        //       value: 6,
        //       label: '5 years'
        //     },
        //     {
        //       value: 7,
        //       label: '6 years'
        //     },
        //     {
        //       value: 8,
        //       label: '7 years'
        //     },
        //     {
        //       value: 9,
        //       label: '8 years'
        //     },
        //     {
        //       value: 10,
        //       label: '9 years'
        //     },
        //     {
        //       value: 11,
        //       label: '10 years'
        //     },
        //     {
        //       value: 12,
        //       label: '11 years'
        //     },
        //     {
        //       value: 13,
        //       label: '12 years'
        //     },
        //     {
        //       value: 14,
        //       label: '13 years'
        //     },
        //     {
        //       value: 15,
        //       label: '14 years'
        //     },
        //     {
        //       value: 16,
        //       label: '15 years'
        //     },
        //     {
        //       value: 17,
        //       label: '16 years'
        //     },
        //     {
        //       value: 18,
        //       label: '17 years'
        //     },
        //     {
        //       value: 19,
        //       label: '18 years+'
        //     }
        //   ]
        // },
        // {
        //   question: 'Household Income',
        //   id: 6,
        //   icon: 'las la-wallet',
        //   answers: [
        //     {
        //       value: 1,
        //       label: 'Under 18.000 EUR'
        //     },
        //     {
        //       value: 2,
        //       label: '18.000 - 35.999 EUR'
        //     },
        //     {
        //       value: 3,
        //       label: '36.000 - 58.999 EUR'
        //     },
        //     {
        //       value: 4,
        //       label: '59.000 - 85.999 EUR'
        //     },
        //     {
        //       value: 5,
        //       label: '86.000 - 129.999 EUR'
        //     },
        //     {
        //       value: 6,
        //       label: '130.000 - 176.999 EUR'
        //     },
        //     {
        //       value: 7,
        //       label: '177.000 - 224.999 EUR'
        //     },
        //     {
        //       value: 8,
        //       label: 'Over 225.000 EUR'
        //     },
        //     {
        //       value: 9,
        //       label: 'Do not know/Do not want to state'
        //     }
        //   ]
        // },
        {
          question: 'Education',
          id: 7,
          icon: 'las la-graduation-cap',
          answers: [
            {
              value: 1,
              label: 'School'
            },
            {
              value: 2,
              label: 'Vocational education'
            },
            {
              value: 3,
              label: 'Bachelors degree or similar'
            },
            {
              value: 4,
              label: 'Master degree or similar or above'
            }
          ]
        }
      ],
      behaviours: [
        {
          question: 'Preferred holiday type',
          id: 4022,
          icon: 'near_me',
          answers: [
            { value: 1, label: 'Sun and beach holiday' },
            { value: 2, label: 'Skiing holiday' },
            { value: 3, label: 'Golf holiday' },
            { value: 4, label: 'Diving holiday' },
            {
              value: 6,
              label: 'Relaxing (unwind, getting into a lower gear)'
            },
            {
              value: 7,
              label:
                'Cultural holiday (where historical and cultural experiences are the main purpose)'
            },
            { value: 8, label: 'Cruise holiday' },
            {
              value: 9,
              label:
                'Multi destination tour (multiple locations/destinations in one holiday)'
            },
            {
              value: 10,
              label: 'Sharing with a predefined group of people (min. 8 pax)'
            },
            { value: 11, label: 'Big city holiday' },
            {
              value: 12,
              label: 'Spiritual, pilgrimage or practicing religion'
            },
            {
              value: 13,
              label:
                'Special occation travel, eg. Stag or hen party, anniversary or birthday celebration'
            },
            {
              value: 14,
              label: 'Volunteering as part of the holiday'
            },
            { value: 15, label: 'Birdwatching, Safari' },
            { value: 16, label: 'Wedding or honeymoon' },
            {
              value: 17,
              label: 'Attending Festivals, cultural events'
            },
            {
              value: 18,
              label: 'Visiting friends and family'
            },
            {
              value: 19,
              label: 'Gastronomic/culinary/wine experiences'
            },
            {
              value: 20,
              label:
                'Doing something good for myself (wellness, retreat, yoga, spa)'
            },
            {
              value: 21,
              label:
                'Combining business and pleasure (extending business travel)'
            },
            { value: 22, label: 'Study trips' },
            {
              value: 23,
              label:
                'Workation (travelling to a destination to work remotely from there)'
            },
            { value: 24, label: 'Attending Sports events' },
            {
              value: 25,
              label:
                'Attending other events of special interest (tech, media, comics, innovation)'
            },
            { value: 26, label: 'Hiking/trekking holiday' },
            {
              value: 27,
              label: 'Cycling holiday (MTB and road cycling)'
            },
            {
              value: 28,
              label:
                'Other active holiday (Climbing, riding, surf/kitesurf, etc.)'
            },
            {
              value: 29,
              label:
                'Health related travel, eg. traveling for the purpose of having an hair transplant'
            },
            {
              value: 30,
              label: 'Mountain and wilderness holiday'
            },
            {
              value: 31,
              label: 'Small and unique towns holiday'
            }
          ]
        },
        {
          question: 'Preferred type of accommodation',
          id: 4021,
          icon: 'luggage',
          answers: [
            {
              value: 1,
              label: 'Camping (caravan, autocamper, mobile home, tent)'
            },
            { value: 2, label: 'Glamping (luxury camping)' },
            {
              value: 3,
              label: 'Boating (house boat, yacht)'
            },
            { value: 4, label: 'Luxury suite/villa' },
            {
              value: 5,
              label: 'Holiday home (not my own privately owned home)'
            },
            {
              value: 6,
              label: 'Private rental (e.g. Airbnb, Homeaway, house swap)'
            },
            {
              value: 7,
              label: 'My own private home at the destination'
            },
            { value: 8, label: 'Bed and Breakfast' },
            { value: 9, label: 'Budget Hotel/Hostel' },
            { value: 10, label: 'Farmhouse' },
            {
              value: 11,
              label: 'Traditional/ Historic property'
            },
            { value: 12, label: '3-4* Hotel' },
            { value: 13, label: 'Luxury Hotel (5+*)' },
            { value: 14, label: 'Boutique Hotel' },
            { value: 15, label: 'City hotel' },
            {
              value: 16,
              label:
                'Globally recognised hotel brand (Hilton, Marriott, Sheraton, etc.)'
            },
            { value: 17, label: 'Resort' },
            { value: 18, label: 'Cruise' },
            { value: 19, label: 'Spa hotel' },
            {
              value: 20,
              label: 'Contemporary style accommodation/design hotel'
            },
            {
              value: 21,
              label: 'Staying with friends or family'
            }
          ]
        },
        {
          question: 'Online Inspiration',
          id: 16,
          icon: 'search',
          answers: [
            {
              value: 2,
              label: 'Facebook'
            },
            {
              value: 3,
              label: 'Instagram'
            },
            {
              value: 4,
              label: 'Snapchat'
            },
            {
              value: 5,
              label: 'Twitter'
            },
            {
              value: 6,
              label: 'Blogs'
            },
            {
              value: 7,
              label: 'Podcasts'
            },
            {
              value: 8,
              label: 'TikTok'
            },
            {
              value: 9,
              label: 'Youtube'
            },
            {
              value: 10,
              label: 'Online reviews sites (Tripadvisor, etc.)'
            },
            {
              value: 12,
              label: 'Online media'
            },
            {
              value: 13,
              label: 'Online lifestyle and travel magazines'
            },
            {
              value: 15,
              label: 'Influencers and celebrities'
            },
            {
              value: 20,
              label: 'Search engines (Google, Bing..)'
            },
            {
              value: 21,
              label: 'Online Travel Agencies'
            },
            {
              value: 22,
              label: 'Travel company websites (airline, hotels, etc.)'
            },
            {
              value: 24,
              label: 'Twitch'
            },
            {
              value: 26,
              label: 'Oficial tourism board / office website'
            },
            {
              value: 31,
              label: 'Whatsapp'
            },
            {
              value: 32,
              label: 'Pinterest'
            },
            {
              value: 33,
              label:
                'TV series on demand (Netfix, HBO, Disney+, Amazon Prime, etc.)'
            },
            {
              value: 34,
              label: 'TV series live'
            }
          ]
        },
        {
          question: 'Inspiration Offline',
          id: 1016,
          icon: 'las la-search-location',
          answers: [
            {
              value: 1,
              label: 'Family & friends'
            },
            {
              value: 11,
              label: 'Newspapers and Supplements'
            },
            {
              value: 16,
              label: 'Cinema/movies'
            },
            {
              value: 17,
              label: 'TV advertising'
            },
            {
              value: 18,
              label: 'Travel TV programmes'
            },
            {
              value: 19,
              label: 'Radio'
            },
            {
              value: 27,
              label: 'Outdoor advertising'
            },
            {
              value: 28,
              label: 'Promotional Events'
            },
            {
              value: 29,
              label: 'Travel agency recommendation / Shop windows'
            },
            {
              value: 30,
              label: 'Lifestyle and travel print magazines'
            }
          ]
        },
        // {
        //   question: 'Booking',
        //   id: 4020,
        //   icon: 'store',
        //   answers: [
        //     {
        //       value: 1,
        //       label:
        //         'Book package trip (flight+accommodation) online with a travel agency website - OTA'
        //     },
        //     {
        //       value: 2,
        //       label:
        //         'Book package trip (flight+accommodation) with a travel agent in person or via phone/email'
        //     },
        //     {
        //       value: 3,
        //       label:
        //         'Book separate flight and hotel online via different booking portals/travel agencies'
        //     },
        //     {
        //       value: 4,
        //       label:
        //         'Book package (flight and accommodation) direct with local operator'
        //     },
        //     {
        //       value: 7,
        //       label:
        //         'Book separate - Use price comparison site to book a trip (e.g. Momondo, Trivago, Skyscanner)'
        //     },
        //     {
        //       value: 8,
        //       label:
        //         'Book separate - accommodation/transportation (flight/cruise/etc.) in providers direct website'
        //     }
        //   ]
        // },
        {
          question: 'Transportation',
          id: 5019,
          icon: 'las la-car',
          answers: [
            { value: 1, label: 'Own vehicle' },
            { value: 2, label: 'Rental Car' },
            { value: 3, label: 'Bus' },
            { value: 4, label: 'Train' },
            {
              value: 5,
              label: 'Flight first class/business class'
            },
            {
              value: 6,
              label: 'Flight premium economy / economy'
            },
            { value: 7, label: 'Ferry' },
            {
              value: 8,
              label: 'Private boats (small cruices / yatching)'
            },
            { value: 9, label: 'Cruise' },
            { value: 10, label: 'Other (bike, etc)' }
          ]
        },
        {
          question: 'Apprehension level',
          id: 1021,
          icon: 'las la-asterisk',
          answers: [
            {
              value: 1,
              label: 'Yes, definitely'
            },
            {
              value: 2,
              label: 'Yes, if I myself feel that it is safe'
            },
            {
              value: 3,
              label: 'Maybe if it is a really good offer'
            },
            {
              value: 4,
              label: 'No'
            }
          ]
        },
        {
          question: 'Social And Environmental Responsibility',
          id: 1019,
          icon: 'las la-dove',
          answers: [
            {
              value: 1,
              label: 'Compensated CO2 emissions'
            },
            {
              value: 2,
              label: 'Chosen a train or bus over a plane ticket'
            },
            {
              value: 3,
              label:
                'Taken part in a rural / local community experience to share their domestic life'
            },
            {
              value: 4,
              label: 'Supported a social conservation project (activism)'
            },
            {
              value: 5,
              label:
                'Supported a environmental / biodiversity conservation project (activism)'
            },
            {
              value: 6,
              label:
                'Chosen ecofriendly accommodation in spite of costing more than a regular one'
            },
            {
              value: 7,
              label: 'None of the above'
            }
          ]
        }
      ],
      catalysts: [
        {
          question:
            'Cultural & Historical Experiences (Museums, cultural & historical sites)',
          id: 167,
          icon: 'las la-landmark'
        },
        {
          question: 'Going to the beach',
          id: 137,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Shopping',
          id: 132,
          icon: 'las la-shopping-bag'
        },
        {
          question: 'Being active (Sport, adventure)',
          id: 148,
          icon: 'las la-running'
        },
        {
          question: 'Wellness/Spa',
          id: 139,
          icon: 'las la-spa'
        },
        {
          question: 'Nature/outdoor experiences',
          id: 133,
          icon: 'las la-mountain'
        },
        {
          question: 'Big city experiences',
          id: 150,
          icon: 'las la-city'
        },
        {
          question: 'Food experiences',
          id: 140,
          icon: 'las la-utensils'
        },
        {
          question: 'Fine dining',
          id: 141,
          icon: 'las la-concierge-bell'
        },
        {
          question:
            'Gaining a new skill/developing skill, e.g. language, cooking or similar',
          id: 138,
          icon: 'las la-sign-language'
        },
        {
          question: 'Interacting with locals',
          id: 153,
          icon: 'las la-language'
        },
        {
          question: 'All inclusive accommodation options',
          id: 158,
          icon: 'las la-wallet'
        },
        {
          question: 'Nightlife',
          id: 164,
          icon: 'las la-glass-cheers'
        },
        {
          question: 'Photography',
          id: 165,
          icon: 'las la-camera'
        },
        {
          question:
            'Agenda of Sport Events (Football World cup / Regional tournaments / Wimbledon / Olympics / Formula1)',
          id: 168,
          icon: 'las la-basketball-ball'
        },
        {
          question: 'Agenda of Festivals, Concerts & Events',
          id: 169,
          icon: 'las la-theater-masks'
        },
        {
          question:
            'The possibility to practice a specific preferred activity as ski, diving, surf, kitesurf, golf, etc.',
          id: 181,
          icon: 'las la-praying-hands'
        },
        {
          question: 'Going to the mountain and wilderness',
          id: 184,
          icon: 'las la-mountain'
        },
        {
          question: 'Visiting small and unique towns',
          id: 185,
          icon: 'las la-igloo'
        },
        {
          question:
            'Possibility of a spiritual experience, pilgrimage or practice religion',
          id: 180,
          icon: 'las la-praying-hands'
        }
      ],
      enablers: [
        {
          question: 'Opportunities to make social media content',
          id: 182,
          icon: 'las la-hashtag'
        },
        {
          question: 'Price level in the country (affordability)',
          id: 127,
          icon: 'las la-hand-holding-usd'
        },
        {
          question: 'Environmental concerns and sustainability',
          id: 128,
          icon: 'las la-leaf'
        },
        {
          question: 'Safety standards/low crime levels',
          id: 129,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Cleanliness',
          id: 131,
          icon: 'las la-broom'
        },
        {
          question: 'Guided/Arranged tours/experiences',
          id: 149,
          icon: 'las la-users'
        },
        {
          question: 'Child friendliness',
          id: 130,
          icon: 'las la-baby-carriage'
        },
        {
          question: 'That the destination has few tourists',
          id: 142,
          icon: 'las la-user-alt-slash'
        },
        {
          question: 'Living new experiences',
          id: 151,
          icon: 'las la-fire-alt'
        },
        {
          question: 'Meeting new people',
          id: 152,
          icon: 'las la-user-friends'
        },
        {
          question: 'Easy access to health and medical facilities',
          id: 154,
          icon: 'las la-ambulance'
        },
        {
          question: 'Accessibility for less mobile',
          id: 155,
          icon: 'las la-wheelchair'
        },
        {
          question: 'LGBTQ+- friendliness',
          id: 156,
          icon: 'las la-mercury'
        },
        {
          question: 'Direct flight',
          id: 159,
          icon: 'las la-plane'
        },
        {
          question: 'Flights from my local airport',
          id: 160,
          icon: 'las la-plane-departure'
        },
        {
          question: 'Being able to drive to the destination',
          id: 161,
          icon: 'las la-truck-pickup'
        },
        {
          question: 'Health and hygiene standards',
          id: 162,
          icon: 'las la-notes-medical'
        },
        {
          question: 'Pet friendliness',
          id: 163,
          icon: 'las la-dog'
        },
        {
          question:
            'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
          id: 166,
          icon: 'las la-wallet'
        },
        {
          question: 'Backpacker friendliness',
          id: 170,
          icon: 'backpack'
        },
        {
          question: 'Premium/luxury accommodation options',
          id: 183,
          icon: 'las la-wallet'
        }
      ],
      plannings: [
        {
          question: 'Annual household holiday budget',
          id: 8,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: '0-1.000 EUR'
            },
            {
              value: 2,
              label: '1.000-2.999 EUR'
            },
            {
              value: 3,
              label: '3.000-4.999 EUR'
            },
            {
              value: 4,
              label: '5.000-9.999 EUR'
            },
            {
              value: 5,
              label: '10.000-19.999 EUR'
            },
            {
              value: 6,
              label: '20.000-29.999 EUR'
            },
            {
              value: 7,
              label: '30.000-39.999 EUR'
            },
            {
              value: 8,
              label: '40.000-49.999 EUR'
            },
            {
              value: 9,
              label: '50000 EUR or more'
            },
            {
              value: 10,
              label: 'Do not know/Do not want to state'
            }
          ]
        },
        {
          question: 'Budget compared to previous year',
          id: 9,
          icon: 'legend_toggle',
          answers: [
            {
              value: 1,
              label: 'Less than last year'
            },
            {
              value: 2,
              label: 'Same as last year'
            },
            {
              value: 3,
              label: 'More than last year'
            },
            {
              value: 4,
              label: 'Do not know'
            }
          ]
        },
        {
          question: 'Domestic Short holidays (up to 4 days)',
          id: 1274,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'Domestic Long holidays (5 days or more)',
          id: 1255,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Short holidays (up to 4 days)',
          id: 1254,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'International Long holidays (5 days or more)',
          id: 1265,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Short holidays (up to 4 days)',
          id: 1264,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Long holidays (5 days or more)',
          id: 1275,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: 'January'
            },
            {
              value: 2,
              label: 'February'
            },
            {
              value: 3,
              label: 'March'
            },
            {
              value: 4,
              label: 'April'
            },
            {
              value: 5,
              label: 'May'
            },
            {
              value: 6,
              label: 'June'
            },
            {
              value: 7,
              label: 'July'
            },
            {
              value: 8,
              label: 'August'
            },
            {
              value: 9,
              label: 'September'
            },
            {
              value: 10,
              label: 'October'
            },
            {
              value: 11,
              label: 'November'
            },
            {
              value: 12,
              label: 'December'
            },
            {
              value: 13,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Short holidays (up to 4 days)',
          id: 1164,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question: 'European Long holidays (5 days or more)',
          id: 1165,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question:
            'International outside Europe Short holidays (up to 4 days)',
          id: 1154,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        },
        {
          question:
            'International outside Europe Long holidays (5 days or more)',
          id: 1155,
          icon: 'event_note',
          answers: [
            {
              value: 1,
              label: '1'
            },
            {
              value: 2,
              label: '2'
            },
            {
              value: 3,
              label: '3'
            },
            {
              value: 4,
              label: '4'
            },
            {
              value: 5,
              label: '5'
            },
            {
              value: 6,
              label: '6'
            },
            {
              value: 7,
              label: '7'
            },
            {
              value: 8,
              label: '8'
            },
            {
              value: 9,
              label: '9'
            },
            {
              value: 10,
              label: '10+'
            },
            {
              value: 11,
              label: 'None'
            }
          ]
        }
      ],
      barriers: [
        {
          question: 'Political instability in destination',
          id: 1617,
          icon: 'las la-city'
        },
        {
          question: 'Political instability in my country',
          id: 1618,
          icon: 'las la-landmark'
        },
        {
          question: 'Threat of terrorist attack',
          id: 1619,
          icon: 'las la-shield-alt'
        },
        {
          question: 'Global health concerns (covid, monkey pox)',
          id: 1620,
          icon: 'las la-heart'
        },
        {
          question: 'International conflicts',
          id: 1621,
          icon: 'las la-exclamation-triangle'
        },
        {
          question: 'Inconvenience in airports (delays/cancellations)',
          id: 1622,
          icon: 'las la-plane-arrival'
        },
        {
          question: 'Increase of cost of holidays',
          id: 1623,
          icon: 'las la-umbrella-beach'
        },
        {
          question: 'Cost of living increase affecting disposable income',
          id: 1624,
          icon: 'las la-money-bill'
        },
        {
          question: 'Natural disasters or extreme weather at the destination',
          id: 1625,
          icon: 'las la-snowflake'
        }
      ]
    },
    filterOptions2024B
  };
}
